// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T16:15:19.944Z
// Property: The Heights at Rock Hill (ID: 6767906449165947)
// Collections: 22 amenities, 4 floorplans (live), 32 photos, 68 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449165947",
  "property_external_id": "5479332",
  "property_zillow_url": "https://www.zillow.com/apartments/rock-hill-sc/the-heights-at-rock-hill/CZbwfc/",
  "property_apartments_url": "https://www.apartments.com/the-summit-at-rock-hill-rock-hill-sc/63l7fzr/",
  "property_google_business_url": "https://www.google.com/maps/place/The+Heights+at+Rock+Hill/data=!4m2!3m1!1s0x0:0xbf31608062cd3d7c?sa=X&ved=2ahUKEwjBoavVz7ySAxV3kJUCHc5tEUAQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "32453291088",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-heights-at-rock-hill",
  "property_name": "The Heights at Rock Hill",
  "property_website_url": "https://www.theheightsatrockhill.com/",
  "property_domain": "https://www.theheightsatrockhill.com/",
  "property_address": "1914 Paces Landing Ave",
  "property_full_address": "1914 Paces Landing Ave, Rock Hill, SC 29732",
  "property_address_1": "1914 Paces Landing Ave",
  "property_address_2": null,
  "property_address_city": "Rock Hill",
  "property_address_state": "SC",
  "property_address_zip_full": "29732-1702",
  "property_address_zip": "29732",
  "property_address_country": "US",
  "property_address_county": "York County",
  "property_neighborhood_address": "Outlying York County",
  "property_address_latitude": "34.9861948",
  "property_address_longitude": "-80.9892909",
  "property_email": "Heightsatrockhill@rrliving.com",
  "property_phone": "(803) 877-6363",
  "property_call_tracking_phone": "803-672-6232",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At The Heights at Rock Hill, your ideal living space awaits! Choose from spacious one- or two-bedroom floor plans, each featuring modern amenities like vaulted ceilings, oversized closets, and private balconies. Enjoy community perks such as a wellness studio, playground, and lighted tennis courts. Your new home is just a click away!",
  "property_long_description": "Welcome to The Heights at Rock Hill, the premier apartment community nestled in the heart of Rock Hill, SC. Choose from our thoughtfully designed floor plans that include spacious one-bedroom and two-bedroom apartments, perfect for any lifestyle. Each home boasts modern amenities that blend comfort with convenience, including ceiling fans, oversized closets, and private patios or balconies for relaxing evenings.\n\nElevate your living experience with our luxury amenities, including a state-of-the-art wellness studio, a playground area for the little ones, and a poolside grilling space that makes entertaining a breeze. Stay active on our lighted tennis court or unwind by the scenic poolside. We also offer a Preferred Employer Program for local businesses like Black and Decker and Pepsi, ensuring our residents enjoy tailored perks.\n\nRest easy knowing our 24-hour emergency maintenance services are just a call away, keeping your home a haven of peace. Enjoy the modern touches of brushed nickel finishes, wood-style flooring, and kitchens equipped with black appliances, microwaves, and dishwashers—all designed to elevate your everyday living.\n\nReady to find your new home? Browse our availability today or schedule a personalized tour to discover everything The Heights at Rock Hill has to offer. Experience the perfect blend of style, comfort, and community living—your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-93b3-712b-a21b-4e4fc7ab38ea.webp",
  "property_featured_image_media": {
    "alt_text": "Pool area with fire pit and seating",
    "public_id": "019e1dd4-93b3-712b-a21b-4e4fc7ab38ea",
    "storage_key": "property/6767906449165947/019e1dd4-93b3-712b-a21b-4e4fc7ab38ea.webp",
    "width": 1920,
    "height": 1288
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "230",
  "property_year_built": "1989",
  "property_year_renovated": null,
  "property_walk_score": "19",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.43478260869566",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Maximum of 2 pets per home. No breed restrictions.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://theheightsatrockhill.loftliving.com/login",
  "property_apply_now_url": "https://9192027.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-87a9-741b-b5eb-bd21595eba49.webp",
  "property_primary_logo_media": {
    "alt_text": "The Heights at Rock Hill logo with stylized H.",
    "public_id": "019e1dd4-87a9-741b-b5eb-bd21595eba49",
    "storage_key": "property/6767906449165947/019e1dd4-87a9-741b-b5eb-bd21595eba49.webp",
    "width": 1284,
    "height": 713
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-87a9-741b-b5eb-bd21595eba49.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Heights at Rock Hill logo with stylized H.",
    "public_id": "019e1dd4-87a9-741b-b5eb-bd21595eba49",
    "storage_key": "property/6767906449165947/019e1dd4-87a9-741b-b5eb-bd21595eba49.webp",
    "width": 1284,
    "height": 713
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e84c0-c4f3-70f9-ba22-b34f7fb963ce.webp",
  "property_icon_media": {
    "alt_text": "The letter H in a stylized font with white and beige lines on a black background.",
    "public_id": "019e84c0-c4f3-70f9-ba22-b34f7fb963ce",
    "storage_key": "property/6767906449165947/019e84c0-c4f3-70f9-ba22-b34f7fb963ce.webp",
    "width": 3072,
    "height": 1728
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e84c0-c88d-7428-82e2-9e6500d3e42f.webp",
  "property_fav_icon_media": {
    "alt_text": "The stylized letter H logo with a dark background.",
    "public_id": "019e84c0-c88d-7428-82e2-9e6500d3e42f",
    "storage_key": "property/6767906449165947/019e84c0-c88d-7428-82e2-9e6500d3e42f.webp",
    "width": 3072,
    "height": 1728
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd5-bfbe-76ad-aafd-d22337caebd1.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019e1dd5-bfbe-76ad-aafd-d22337caebd1",
    "storage_key": "property/6767906449165947/019e1dd5-bfbe-76ad-aafd-d22337caebd1.webp",
    "width": 1280,
    "height": 710
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd5-9d43-7560-8623-3af63a5d8e9e.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019e1dd5-9d43-7560-8623-3af63a5d8e9e",
    "storage_key": "property/6767906449165947/019e1dd5-9d43-7560-8623-3af63a5d8e9e.webp",
    "width": 1280,
    "height": 710
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000b2d",
  "property_secondary_color": "#b49e84",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "558 - 1113",
  "property_sqft_min": "558",
  "property_sqft_max": "1113",
  "property_price_range": "1099 - 1499",
  "property_price_min": "1099",
  "property_price_max": "1499",
  "property_available_units": 22,
  "property_facebook_url": "https://www.facebook.com/p/The-Heights-Apartment-Homes-61576343399072/",
  "property_instagram_url": "https://www.instagram.com/theheights_rrliving",
  "property_twitter_url": null,
  "property_google_place_url": null,
  "property_youtube_url": "https://www.youtube.com/shorts/OpoAQWbD7DI",
  "property_yelp_url": "https://www.yelp.com/biz/the-summit-at-rock-hill-rock-hill",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Heights at Rock Hill",
  "property_home_romance_title": "Embrace Life Together in Your Ideal Apartment Community",
  "property_home_amenities_blurb": "<p>Relax and savor a carefree lifestyle at the newly renovated The Heights at Rock Hill in Rock Hill, South Carolina. Situated just off I-77, away from the hustle and bustle of Charlotte, yet conveniently close to Charlotte Douglas Airport, exciting sporting events like the Carolina Panthers, Carowinds, Galleria Mall, Lake Wylie, and more. The Heights at Rock Hill offers proximity to downtown Rock Hill and Winthrop University, ensuring a pleasant commute.</p>\n<p>Select from our pet-friendly, elegantly designed one, two, and three-bedroom apartment homes, showcasing features like walk-in closets, washer and dryer connections, private patios, balconies, and cozy fireplaces. Embrace the resort-style ambiance we provide at The Heights at Rock Hill, where amenities include a sparkling swimming pool, a Wellness Studio complete with a yoga and cardio room, outdoor barbecue areas with gas grills, and much more. Contact one of our friendly leasing consultants and schedule your tour today!</p>",
  "property_home_floorplans_blurb": "<p>Surrounding the pet-friendly community of The Heights at Rock Hill lies incredible restaurants, intriguing shops, exciting entertainment venues, and engaging parks for you to discover. Located in a prime location in Rock Hill, SC, we invite all of our future and current residents to explore our neighborhood.</p>",
  "property_home_gallery_blurb": "At The Heights at Rock Hill, your ideal lifestyle awaits. Choose from spacious one or two-bedroom floor plans featuring vaulted ceilings, private patios, and modern finishes. Enjoy amenities like a wellness studio, lighted tennis court, and poolside grilling. Picture yourself living here—comfort and convenience blend perfectly in Rock Hill, SC!",
  "property_home_neighborhood_blurb": null,
  "property_home_reviews_blurb": "At The Heights at Rock Hill, residents rave about the vibrant community atmosphere: \"Living here feels like home.\" Nestled in scenic Rock Hill, SC, our apartments offer both comfort and convenience. Curious about our exceptional lifestyle? Dive into our resident reviews to learn why your next chapter should begin here!",
  "property_neighborhood_blurb": "<p>Surrounding the pet-friendly community of The Heights at Rock Hill lies incredible restaurants, intriguing shops, exciting entertainment venues, and engaging parks for you to discover. Located in a prime location in Rock Hill, SC, we invite all of our future and current residents to explore our neighborhood.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Indulge in the premium amenities of our community that are suited for every lifestyle. Soak up the sun by the swimming pool or work out at our wellness studio. Enjoy time at the playground or relax at the clubhouse. Our team is dedicated to taking care of your needs with on-call and on-site maintenance. We can’t wait to show you your new home at The Heights at Rock Hill!</p>",
  "property_applynow_blurb": "At The Heights at Rock Hill, elevated living meets comfort and style in our spacious one- and two-bedroom apartments. Enjoy top-notch amenities like a wellness studio, lighted tennis court, and indulgent poolside grilling area. With modern finishes and convenient connections, your perfect home in Rock Hill awaits—lease online today!",
  "property_contactus_blurb": "At The Heights at Rock Hill, our thoughtfully designed one and two-bedroom apartments blend comfort with modern living in the heart of Rock Hill, SC. Each layout is crafted for optimal space and style, perfect for your lifestyle. Have questions? Contact our leasing team today and begin your next chapter!",
  "property_faqs_blurb": "At The Heights at Rock Hill, each thoughtfully designed one and two-bedroom apartment reflects the vibrant lifestyle of Rock Hill, SC. Curious about our community? Dive into our FAQs page for insights on everything from amenities to local hotspots—your perfect living experience awaits!",
  "property_floorplans_blurb": "At The Heights at Rock Hill, spacious living meets modern comfort. Choose from stylish one-bedroom and two-bedroom floor plans designed for your lifestyle. With a variety of layouts, you'll feel right at home in the heart of Rock Hill, SC. Browse our available apartment homes and find your perfect floor plan today!",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new apartment home quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our community and apartments.</p>",
  "property_interactivemap_blurb": "Welcome to The Heights at Rock Hill, where modern living meets comfort. Choose between stylish one and two-bedroom apartments featuring vaulted ceilings, oversized closets, and private balconies. Enjoy amenities like a wellness studio, playground, and poolside grilling area. Use our interactive community map to find your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At The Heights at Rock Hill, we believe that great friends make great neighbors. With inviting one and two-bedroom floor plans nestled in the heart of Rock Hill, SC, there's plenty of room for laughter and memories. Share the love—refer a friend to our vibrant community today!",
  "property_residentaccess_blurb": "Welcome to The Heights at Rock Hill, where your perfect home awaits! Choose from our stylish one and two-bedroom floor plans. For current residents, easily access your portal to handle rent payments, schedule maintenance, and manage your living experience seamlessly. Join our vibrant community today!",
  "property_reviews_blurb": "At The Heights at Rock Hill, residents rave about the “friendly community vibe and spacious layouts.” Nestled in scenic Rock Hill, SC, our apartments offer a perfect blend of comfort and convenience. See what our residents have to say about living at our community and join the happiness!",
  "property_created_at": "1753982486631",
  "property_scheduletour_blurb": "Experience upscale living at The Heights at Rock Hill in beautiful Rock Hill, SC. Choose from spacious one or two-bedroom floor plans that blend comfort and style. Want to know more? Check out residents’ testimonials and get a glimpse of life in our vibrant community. Schedule a tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to The Heights at Rock Hill! Nestled in the heart of Rock Hill, SC, our community offers spacious one- and two-bedroom floor plans tailored to your lifestyle. Stay tuned for a timely response from our friendly team, ready to assist you on your journey home!",
  "property_virtualtours_blurb": "<p>Take a virtual tour of The Heights at Rock Hill apartments in Rock Hill, SC. Experience our spacious floor plan layouts & modern amenities from the comfort of your home.</p>",
  "property_copyright": "2026 All Rights Reserved. The Heights at Rock Hill",
  "property_seo_title_home": "The Heights at Rock Hill |  Apartments in Rock Hill, SC",
  "property_seo_description_home": "Experience modern living at The Heights at Rock Hill! Choose from stylish one or two-bedroom apartments with top-notch amenities and a vibrant community.",
  "property_seo_title_floorplans": "Floor Plans | Rock Hill, SC Apartments for Rent",
  "property_seo_description_floorplans": "Find your space at The Heights at Rock Hill! Choose from stylish one and two-bedroom floor plans in vibrant Rock Hill, SC. Your ideal home awaits!",
  "property_seo_title_amenities": "Amenities | Rock Hill, SC Apartments for Rent",
  "property_seo_description_amenities": "Elevate your lifestyle at The Heights at Rock Hill! Enjoy spacious floor plans, resort-style amenities, and a community that truly feels like home.",
  "property_seo_title_gallery": "Gallery | Apartments in Rock Hill, SC",
  "property_seo_description_gallery": "Picture life at The Heights at Rock Hill! Enjoy spacious floor plans, resort-style amenities, and a community that feels like home. Your new lifestyle awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | The Heights at Rock Hill Apartments",
  "property_seo_description_virtualtours": "Step into your next home at The Heights at Rock Hill! Take a virtual tour of our one and two-bedroom apartments and envision your new life in Rock Hill, SC.",
  "property_seo_title_interactivemap": "Interactive Map | The Heights at Rock Hill Apartments",
  "property_seo_description_interactivemap": "Discover your ideal apartment at The Heights in Rock Hill, SC! Explore stylish floor plans and amenities with our interactive map today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Rock Hill, SC",
  "property_seo_description_neighborhood": "Uncover the vibrant charm of Rock Hill, SC! The Heights at Rock Hill offers a thriving community packed with local favorites and hidden gems just steps away.",
  "property_seo_title_contact": "Contact Us | The Heights at Rock Hill",
  "property_seo_description_contact": "Discover your dream home at The Heights at Rock Hill! Choose from spacious one or two-bedroom layouts. Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Rock Hill, SC",
  "property_seo_description_faqs": "Discover The Heights at Rock Hill! Check our FAQs for info on luxurious amenities, floor plans, and community offerings in Rock Hill, SC.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Rock Hill, SC",
  "property_seo_description_reviews": "Experience life at The Heights at Rock Hill. Dive into our vibrant community and see what residents love about our spacious layouts and amazing amenities!",
  "property_seo_title_applynow": "Apply Now | Apartments in Rock Hill, SC",
  "property_seo_description_applynow": "Experience comfort at The Heights at Rock Hill! Enjoy spacious one and two-bedroom plans, modern amenities, and a vibrant community. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | The Heights at Rock Hill",
  "property_seo_description_residentaccess": "Elevate your living at The Heights at Rock Hill! Log in to your resident portal for easy rent payment, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | The Heights at Rock Hill",
  "property_seo_description_referafriend": "Refer a friend to The Heights at Rock Hill and enjoy community perks together! Great friends make great neighbors—share the love today!",
  "property_seo_title_scheduletour": "Schedule a Tour | The Heights at Rock Hill",
  "property_seo_description_scheduletour": "Embark on a journey to your new home at The Heights at Rock Hill. Schedule a tour today and experience the charm of Rock Hill living!",
  "property_seo_title_privacy": "Privacy Policy | The Heights at Rock Hill",
  "property_seo_description_privacy": "At The Heights at Rock Hill, your privacy matters. Discover how we protect your information—view our privacy policy today!",
  "property_seo_title_accessibility": "Website Accessibility | The Heights at Rock Hill",
  "property_seo_description_accessibility": "Experience inclusive living at The Heights at Rock Hill. Our commitment to accessibility ensures everyone feels at home in Rock Hill, SC. Join us today!",
  "property_seo_title_sitemap": "Sitemap | The Heights at Rock Hill",
  "property_seo_description_sitemap": "Navigate your way to The Heights at Rock Hill—your future home in Rock Hill, SC. Check out our sitemap for a complete layout of our vibrant community!",
  "property_seo_title_thankyou": "Thank You | The Heights at Rock Hill",
  "property_seo_description_thankyou": "Thank you for reaching out to The Heights at Rock Hill! A team member will be in touch soon to assist you in finding your perfect home in Rock Hill, SC.",
  "property_seo_title_pets": "Pet Policy | Apartments in Rock Hill, SC",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293565100",
  "amenities": [
    {
      "id": "custom_4de513c9-0461-4dd8-b710-0edc70f279c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Wellness Studio",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c52a6039-3833-4240-80ed-31ae99c38b39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e2ec81a4-db64-4a65-8ef5-1e565a8fefa0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Poolside Grilling Area",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bbbf241d-8812-4ed6-bc73-537707a48367",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Preferred Employer Program (Black and Decker, Northern Tool, Pepsi Bottle Company, Frito Lay, West Marine, and PFG Customized Distribution)",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d0604ae-7d29-48b8-af9b-67984986f156",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_81517039-cba5-4785-a796-ae512a1f6a06",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Nest Thermostats & USB Outlets*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dc94465c-a702-47ef-be35-456097f30c55",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Oversized Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd0839ba-baa5-4797-8629-9040f1afe973",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Black Appliances*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b86582b7-b846-4513-bf50-e1cf5b0cd4b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios or Balconies",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d6cb8178-43a4-4eaf-b530-59d05e193176",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Brushed Nickel Finishes & Light Fixture",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_64643739-6445-4242-ae47-d26991c91e03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Style Flooring*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_96140d47-2add-4055-9c86-3a20c1feecc3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Microwaves*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d28cda34-b255-4481-8bee-fe4b440185e1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Dishwasher",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6f7fc6eb-e4d5-4016-badb-85f385fd0594",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ec96c6b-c656-4d7e-94e5-4625b65eb979",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Full‑Size Washer & Dryer Included*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a2b9e3c7-1293-496f-a7ae-ef8d023cb3bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Burning Fireplaces*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_88e26af5-ee04-491a-a1f8-30d9de98560c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Kitchen Pantries",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd57041b-bbf1-485a-8ae5-8d9de0dd0bae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4982a196-0ab1-4d93-a09f-d694b0645ff5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": "Granite Countertops*",
      "amount": "false",
      "description": "*in select apartment homes, call our office for more details",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b35676dd-fe06-43fe-b5d8-56cc7ccb76c7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": " Gas Fire Pit",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_d7edb57b-6806-40fc-b6bc-8c7587b620ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": " Designated Picnic Areas Throughout the Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9323c3eb-0caa-46c1-b5c0-05211fc23953",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "external_id": "false",
      "title": " Black Finishes Throughout*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_81cbcb09-33cb-488c-a87e-e8528ab566ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-b0d1-71c4-a774-fedf87a726e4.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
        "public_id": "01a0f44f-b0d1-71c4-a774-fedf87a726e4",
        "storage_key": "property/6767906449165947/01a0f44f-b0d1-71c4-a774-fedf87a726e4.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded by colorful umbrellas. Perfect for relaxing on a sunny day.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_956985f4-60e2-44dd-92ea-1995c1c01d4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-ab5e-73d0-8fcf-0e51777c1361.webp",
      "image_media": {
        "alt_text": "Modern living room with fireplace, sofa, coffee table, and decorative armchair.",
        "public_id": "01a0f44f-ab5e-73d0-8fcf-0e51777c1361",
        "storage_key": "property/6767906449165947/01a0f44f-ab5e-73d0-8fcf-0e51777c1361.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Cozy and stylish living room featuring a fireplace, comfortable sofa, and elegant decor. Perfect for relaxing or entertaining guests.",
      "link": "",
      "alt_text": "Modern living room with fireplace, sofa, coffee table, and decorative armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0518ac4a-5c7b-430f-9241-c735108ea72d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-a783-77cb-9119-228bc7693e59.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, stainless steel sink, and white cabinets. Dining area and bedroom visible in the background.",
        "public_id": "01a0f44f-a783-77cb-9119-228bc7693e59",
        "storage_key": "property/6767906449165947/01a0f44f-a783-77cb-9119-228bc7693e59.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed apartment, featuring a sleek kitchen with granite countertops and modern appliances, flowing seamlessly into a dining area and a cozy bedroom.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, stainless steel sink, and white cabinets. Dining area and bedroom visible in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4c99a5f8-3eb9-4870-ac4b-28247a18b03c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f469-4f31-710f-aff8-031504ae99a0.webp",
      "image_media": {
        "alt_text": "Cozy and modern living room with plush seating, a large television, and a coffee table.",
        "public_id": "01a0f469-4f31-710f-aff8-031504ae99a0",
        "storage_key": "property/6767906449165947/01a0f469-4f31-710f-aff8-031504ae99a0.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Relax and unwind in our stylish living room, featuring comfortable seating, a large flat-screen TV, and elegant decor. Perfect for socializing or enjoying a quiet evening.",
      "link": "",
      "alt_text": "Cozy and modern living room with plush seating, a large television, and a coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5033c9f-aee1-4fc3-b8ac-4d6113bce2ed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-a9c7-76c9-be77-970da1449111.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool area with lounge chairs and apartment buildings in the background.",
        "public_id": "01a0f44f-a9c7-76c9-be77-970da1449111",
        "storage_key": "property/6767906449165947/01a0f44f-a9c7-76c9-be77-970da1449111.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, surrounded by comfortable lounge chairs and lush greenery.",
      "link": "",
      "alt_text": "Outdoor swimming pool area with lounge chairs and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fca80aa8-dcc7-4d26-95d5-3f613caa3275",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-abb6-72c9-b421-dabc9765bcc8.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by green space and apartment buildings.",
        "public_id": "01a0f44f-abb6-72c9-b421-dabc9765bcc8",
        "storage_key": "property/6767906449165947/01a0f44f-abb6-72c9-b421-dabc9765bcc8.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy our sparkling swimming pool and spacious sundeck, perfect for relaxing and unwinding. The ideal spot to soak up the sun and enjoy the beautiful weather.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by green space and apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c0259b73-341c-45f3-84a0-e138cd1e328f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-aaee-715a-8582-0ba41c5de835.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees.",
        "public_id": "01a0f44f-aaee-715a-8582-0ba41c5de835",
        "storage_key": "property/6767906449165947/01a0f44f-aaee-715a-8582-0ba41c5de835.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool, complete with comfortable lounge chairs and shaded areas for relaxation.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a5e7645f-50fd-4f22-b4db-abaae73a2031",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f468-2704-764f-8120-40c835570c7e.webp",
      "image_media": {
        "alt_text": "The Heights leasing office building with a sign and landscaping.",
        "public_id": "01a0f468-2704-764f-8120-40c835570c7e",
        "storage_key": "property/6767906449165947/01a0f468-2704-764f-8120-40c835570c7e.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Welcome to The Heights leasing office, your first stop for information and tours of our beautiful community.",
      "link": "",
      "alt_text": "The Heights leasing office building with a sign and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_02bf671f-1fc3-477e-800b-5705ff331e16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-a746-72de-9be9-31568d89ea2a.webp",
      "image_media": {
        "alt_text": "Modern living room with plush seating, large TV, and abstract art, overlooking a pool area.",
        "public_id": "01a0f44f-a746-72de-9be9-31568d89ea2a",
        "storage_key": "property/6767906449165947/01a0f44f-a746-72de-9be9-31568d89ea2a.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Relax and unwind in this stylish living area, perfect for socializing or enjoying a quiet moment. Step outside to the sparkling pool for ultimate relaxation.",
      "link": "",
      "alt_text": "Modern living room with plush seating, large TV, and abstract art, overlooking a pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2e3c5e13-959d-4d43-98f0-55504d08a091",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/01a0f44f-a912-748b-aa15-fb26ab11f476.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with trees and parking lot.",
        "public_id": "01a0f44f-a912-748b-aa15-fb26ab11f476",
        "storage_key": "property/6767906449165947/01a0f44f-a912-748b-aa15-fb26ab11f476.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "A well-maintained apartment building exterior surrounded by lush greenery and a paved parking area under a clear blue sky.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with trees and parking lot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c5eaa51-9069-4c9d-b5aa-1a0047a6d40a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-c6da-733e-97ea-fc4c873bf36e.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas outside apartment buildings.",
        "public_id": "019e1dd4-c6da-733e-97ea-fc4c873bf36e",
        "storage_key": "property/6767906449165947/019e1dd4-c6da-733e-97ea-fc4c873bf36e.webp",
        "width": 1920,
        "height": 1288
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and vibrant umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas outside apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d6e065ba-1df2-46c1-a477-e199d3e3add6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-93b3-712b-a21b-4e4fc7ab38ea.webp",
      "image_media": {
        "alt_text": "Pool area with fire pit and seating",
        "public_id": "019e1dd4-93b3-712b-a21b-4e4fc7ab38ea",
        "storage_key": "property/6767906449165947/019e1dd4-93b3-712b-a21b-4e4fc7ab38ea.webp",
        "width": 1920,
        "height": 1288
      },
      "title": "Community",
      "description": "Relax by the pool or gather around the fire pit at our community's outdoor oasis. Perfect for enjoying warm evenings and connecting with neighbors.",
      "link": "",
      "alt_text": "Pool area with fire pit and seating",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_452058a8-376a-4494-89cb-9257cf42ab1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-91c8-714b-9bbb-77b3c08edd51.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, sofa, coffee table, and a red armchair.",
        "public_id": "019e1dd4-91c8-714b-9bbb-77b3c08edd51",
        "storage_key": "property/6767906449165947/019e1dd4-91c8-714b-9bbb-77b3c08edd51.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, comfortable sofa, stylish coffee table, and a decorative armchair, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Living room with a fireplace, sofa, coffee table, and a red armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_20ae62f2-251e-4da9-8154-f04e0d9872bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b45d-72bb-be0b-aaf7e25fe1c9.webp",
      "image_media": {
        "alt_text": "Living room with dining area, fireplace, and open kitchen.",
        "public_id": "019f5d4e-b45d-72bb-be0b-aaf7e25fe1c9",
        "storage_key": "property/6767906449165947/019f5d4e-b45d-72bb-be0b-aaf7e25fe1c9.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a dining space, a cozy fireplace, and a modern open-concept kitchen, perfect for entertaining and everyday living.",
      "link": "",
      "alt_text": "Living room with dining area, fireplace, and open kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0550b7dc-7e9f-4ae7-ad77-7e4c2bc2df11",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-8d83-70dd-be4d-9a9e4cf6a8f8.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstands, lamps, and a sliding glass door leading to a balcony.",
        "public_id": "019e1dd4-8d83-70dd-be4d-9a9e4cf6a8f8",
        "storage_key": "property/6767906449165947/019e1dd4-8d83-70dd-be4d-9a9e4cf6a8f8.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, complete with a queen-size bed, elegant nightstands, and a convenient sliding glass door for easy access to outdoor space.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstands, lamps, and a sliding glass door leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24e2904a-48c7-467d-aa2f-fb691032fdb7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b8ac-752f-8493-32daa384b439.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
        "public_id": "019f5d4e-b8ac-752f-8493-32daa384b439",
        "storage_key": "property/6767906449165947/019f5d4e-b8ac-752f-8493-32daa384b439.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Community",
      "description": "Our fully equipped fitness center features a variety of cardio and strength training equipment to help you stay active and healthy.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ffc85564-a993-4d99-b932-ca7dc410bc1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b3fd-753b-a614-be1c3a9eee2d.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, weight machine, and benches.",
        "public_id": "019f5d4e-b3fd-753b-a614-be1c3a9eee2d",
        "storage_key": "property/6767906449165947/019f5d4e-b3fd-753b-a614-be1c3a9eee2d.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight training equipment, and free weights.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, weight machine, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_918a9a8f-4788-4f21-90a1-bdbb62176e4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-8ac1-753e-afdd-61ecc4cfeae4.webp",
      "image_media": {
        "alt_text": "Stylish living area with a decorative cabinet and mirror, leading to a hallway.",
        "public_id": "019e1dd4-8ac1-753e-afdd-61ecc4cfeae4",
        "storage_key": "property/6767906449165947/019e1dd4-8ac1-753e-afdd-61ecc4cfeae4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this inviting living space, featuring elegant decor and a bright atmosphere. Perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Stylish living area with a decorative cabinet and mirror, leading to a hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6e08810a-f9a7-4e42-a0fd-ac6b4641c751",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-8737-7187-8f07-bf2e3445514d.webp",
      "image_media": {
        "alt_text": "Dining area with a marble-top table and four chairs, featuring modern art on the wall and a glimpse of the kitchen.",
        "public_id": "019e1dd4-8737-7187-8f07-bf2e3445514d",
        "storage_key": "property/6767906449165947/019e1dd4-8737-7187-8f07-bf2e3445514d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Enjoy meals in this stylish dining area, complete with a chic table, comfortable seating, and elegant wall art, seamlessly connected to a modern kitchen.",
      "link": "",
      "alt_text": "Dining area with a marble-top table and four chairs, featuring modern art on the wall and a glimpse of the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ecdd5639-dfb9-43b1-939b-74c3b466661f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-ae46-762b-90ef-4f49b1f1ea7b.webp",
      "image_media": {
        "alt_text": "Modern kitchen with granite countertops, white cabinets, stainless steel refrigerator, and oven.",
        "public_id": "019e1dd4-ae46-762b-90ef-4f49b1f1ea7b",
        "storage_key": "property/6767906449165947/019e1dd4-ae46-762b-90ef-4f49b1f1ea7b.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Discover your new home in this beautifully updated kitchen, featuring sleek granite countertops, ample white cabinetry, and modern stainless steel appliances.",
      "link": "",
      "alt_text": "Modern kitchen with granite countertops, white cabinets, stainless steel refrigerator, and oven.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3821c17e-8842-46ff-bf3e-38402528388a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-acaa-752e-96ca-ce4462e00ad5.webp",
      "image_media": {
        "alt_text": "Stainless steel refrigerator, microwave, and oven in a modern apartment kitchen.",
        "public_id": "019e1dd4-acaa-752e-96ca-ce4462e00ad5",
        "storage_key": "property/6767906449165947/019e1dd4-acaa-752e-96ca-ce4462e00ad5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Discover a beautifully appointed kitchen featuring modern stainless steel appliances, including a refrigerator, microwave, and oven, perfect for all your culinary needs.",
      "link": "",
      "alt_text": "Stainless steel refrigerator, microwave, and oven in a modern apartment kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ba23476-ce0f-44f2-b6b9-1ef0dfcf4d04",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-a2bf-72f9-8811-e76ce446aaa5.webp",
      "image_media": {
        "alt_text": "Interior view of an empty apartment room with large windows and a door leading to a balcony.",
        "public_id": "019e1dd4-a2bf-72f9-8811-e76ce446aaa5",
        "storage_key": "property/6767906449165947/019e1dd4-a2bf-72f9-8811-e76ce446aaa5.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious apartment interior featuring large windows with blinds and a glass door, offering a view of the outdoors. The room has wood-look flooring and neutral walls, ready for your personal touch.",
      "link": "",
      "alt_text": "Interior view of an empty apartment room with large windows and a door leading to a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_652ecfab-47a5-47f6-a4b3-1a769f27097e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-bea0-727d-b978-0a105c4bee62.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
        "public_id": "019e1dd4-bea0-727d-b978-0a105c4bee62",
        "storage_key": "property/6767906449165947/019e1dd4-bea0-727d-b978-0a105c4bee62.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Discover this beautifully appointed kitchen featuring stainless steel appliances, sleek granite countertops, and ample white cabinetry for all your storage needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and white cabinetry.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_473ca26a-d894-47f9-b531-9c34811714cd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-d4f0-72cb-9049-1a668bdb721d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "019e1dd4-d4f0-72cb-9049-1a668bdb721d",
        "storage_key": "property/6767906449165947/019e1dd4-d4f0-72cb-9049-1a668bdb721d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space for all your culinary needs.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_34625122-3181-4dbe-aa85-7fe83e93fead",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-ced3-721c-a4df-f3a6c0346477.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room.",
        "public_id": "019e1dd4-ced3-721c-a4df-f3a6c0346477",
        "storage_key": "property/6767906449165947/019e1dd4-ced3-721c-a4df-f3a6c0346477.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer for your convenience.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry room.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab3f129a-d86e-4332-adb7-fb120f4bfcac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-d628-7037-9e65-bd69520074c4.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, sink, and black faucet. Features a bathtub with white tile surround and a toilet.",
        "public_id": "019e1dd4-d628-7037-9e65-bd69520074c4",
        "storage_key": "property/6767906449165947/019e1dd4-d628-7037-9e65-bd69520074c4.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Apartment",
      "description": "Step into a clean and updated bathroom, complete with a stylish vanity, modern fixtures, and a pristine tub/shower combination. Perfect for relaxing after a long day.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, sink, and black faucet. Features a bathtub with white tile surround and a toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_57092764-69f7-45de-86f5-61d8acf1c068",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b935-71c6-802b-8978a169ed7a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and decorative wall baskets.",
        "public_id": "019f5d4e-b935-71c6-802b-8978a169ed7a",
        "storage_key": "property/6767906449165947/019f5d4e-b935-71c6-802b-8978a169ed7a.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Explore this stylish kitchen featuring sleek white cabinetry, elegant granite countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with white cabinets, granite countertops, stainless steel appliances, and decorative wall baskets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_000a6add-2c66-464f-891c-ecce956f370c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b919-70fc-92cf-3916360e068e.webp",
      "image_media": {
        "alt_text": "Outdoor patio with orange Adirondack chairs and a covered fire pit.",
        "public_id": "019f5d4e-b919-70fc-92cf-3916360e068e",
        "storage_key": "property/6767906449165947/019f5d4e-b919-70fc-92cf-3916360e068e.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Community",
      "description": "Relax and unwind on our spacious outdoor patio, complete with comfortable seating and a cozy fire pit.",
      "link": "",
      "alt_text": "Outdoor patio with orange Adirondack chairs and a covered fire pit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cc26877c-3329-49c1-be33-05f3efcb13ea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b8c1-751a-b655-773c74be0dd1.webp",
      "image_media": {
        "alt_text": "Modern bathroom with white tub, shower, vanity with black fixtures, and large mirror.",
        "public_id": "019f5d4e-b8c1-751a-b655-773c74be0dd1",
        "storage_key": "property/6767906449165947/019f5d4e-b8c1-751a-b655-773c74be0dd1.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Freshen up in a bright and clean bathroom featuring a spacious white tub and shower, a modern vanity with ample storage, and a large mirror to complete the space.",
      "link": "",
      "alt_text": "Modern bathroom with white tub, shower, vanity with black fixtures, and large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3551a44-be0e-4559-967c-ab29b8b3412b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b860-71ca-bfd9-a33e3d105af9.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, abstract art, and a view into the bathroom.",
        "public_id": "019f5d4e-b860-71ca-bfd9-a33e3d105af9",
        "storage_key": "property/6767906449165947/019f5d4e-b860-71ca-bfd9-a33e3d105af9.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a plush queen bed, elegant abstract wall art, and a beautifully appointed ensuite bathroom.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, abstract art, and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d694b994-eb8e-4351-b814-6fd01e464d7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b41e-7048-9719-667499a629f6.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, beige sofa, and modern armchair.",
        "public_id": "019f5d4e-b41e-7048-9719-667499a629f6",
        "storage_key": "property/6767906449165947/019f5d4e-b41e-7048-9719-667499a629f6.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a cozy fireplace, a comfortable beige sofa, and stylish seating. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, beige sofa, and modern armchair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_7fe4af56-f2aa-498b-ab72-aa13d3d0588f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019f5d4e-b8d8-708d-ab50-1ae6dcb6d964.webp",
      "image_media": {
        "alt_text": "In-unit laundry room with washer, dryer, and bathroom",
        "public_id": "019f5d4e-b8d8-708d-ab50-1ae6dcb6d964",
        "storage_key": "property/6767906449165947/019f5d4e-b8d8-708d-ab50-1ae6dcb6d964.webp",
        "width": 1997,
        "height": 1333
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer, with easy access to the bathroom for added convenience.",
      "link": "",
      "alt_text": "In-unit laundry room with washer, dryer, and bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c87a6f6a-1454-44e4-b7a9-4b78148d55e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rosewood Elementary School",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4f1136d4-195f-4eb3-b6a1-4aff47aa4c85",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "India Hook Elementary School",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a4e9ef4d-07cf-428c-871e-8508708eecb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "W. C. Sullivan Middle School",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_62704f0b-0991-4816-88f7-3565ba510ee3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Fort Mill High",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ad9815e4-e26a-475c-a5d4-394552253570",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rock Hill High School",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8041388-499f-4a06-b383-f429723a4797",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Westminster Catawba Christian School",
      "poi_type": "Education",
      "poi_address": "",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "false",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_eb5dc6bd-f549-478b-84d3-8476b6f8efe4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Starbucks Coffee Company",
      "poi_type": "Restaurants",
      "poi_address": "1303 Riverchase Blvd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Welcoming coffeehouse with handcrafted coffee, espresso & tea, plus breakfast, lunch & pastries.",
      "poi_long_description": "This cafe is praised for consistently serving well-made drinks, such as caramel Frappuccinos and pumpkin spice lattes, and for its convenient location. Reviewers also consistently mention the friendly, kind, and courteous staff.\n\nSome reviews mention the service can be disorganized.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8388-7283-97f8-c7b94b2ffe5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddc1-8388-7283-97f8-c7b94b2ffe5f",
        "storage_key": "property/6767906449165947/019fddc1-8388-7283-97f8-c7b94b2ffe5f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.starbucks.com/store-locator/store/15658/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8351051430724763298&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "starbucks-coffee-company",
      "poi_latitude": "34.9763482",
      "poi_longitude": "-80.9896534",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-980-2650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2761ead147cb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2761ead147cb",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2761ead147cb.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJKyvIq1ePVogRov5dzQfl5HM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_9a270902-b3af-47c6-8c65-0a45be0d9409",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "The Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "2349 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Shopping center featuring several shops, a grocery store, and ample parking.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-84dd-736f-b8a8-1f6c8da64b75.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddc1-84dd-736f-b8a8-1f6c8da64b75",
        "storage_key": "property/6767906449165947/019fddc1-84dd-736f-b8a8-1f6c8da64b75.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10499685842246128525&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-market",
      "poi_latitude": "34.968924",
      "poi_longitude": "-80.9966037",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-325-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ18AJRa2IVogRjVNH0KRgtpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_715b4ed1-72bc-4ada-a9b4-39ea88efcd57",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 Springsteen Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-84bd-715a-8341-e1418b21a217.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddc1-84bd-715a-8341-e1418b21a217",
        "storage_key": "property/6767906449165947/019fddc1-84bd-715a-8341-e1418b21a217.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/rock-hill/1371",
      "poi_directions_map_url": "https://maps.google.com/?cid=5851719844173323408&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "34.93889850000001",
      "poi_longitude": "-80.978044",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-985-3040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJj2ydgiSGVogRkBwOzTF8NVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_23ae2e05-93c2-4fc9-9991-5d4989809971",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rock Hill Lake Park - Lake Wylie Dam",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4037 India Hook Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Laid-back swimming area with a beach and spots to fish, plus a picnic area.",
      "poi_long_description": "Visitors say this park offers a clean swim beach, walking trails, and fishing spots, along with picnic tables and swings. They also highlight the convenient public restrooms and the family-friendly atmosphere. Others mention the staff are super nice and extremely helpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc2-01dc-75eb-8613-db02350bab8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fddc2-01dc-75eb-8613-db02350bab8c",
        "storage_key": "property/6767906449165947/019fddc2-01dc-75eb-8613-db02350bab8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/165/151?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=11649216530073986679&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-lake-park---lake-wylie-dam",
      "poi_latitude": "35.0148524",
      "poi_longitude": "-81.0090211",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc2-071f-76db-a6bf-ca66be96e9db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc2-071f-76db-a6bf-ca66be96e9db",
        "storage_key": "property/6767906449165947/019fddc2-071f-76db-a6bf-ca66be96e9db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-pbckCPVogRdyarwrZUqqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_85cfcb76-cd6d-4c2f-acdd-0fb6a117e43f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Lidl",
      "poi_type": "Shopping & Retail",
      "poi_address": "1260 Herrons Ferry Road, Rock Hill, SC 29730, USA",
      "poi_short_description": "Discount supermarket chain stocking a wide selection of organic and international products.",
      "poi_long_description": "People say this grocery store offers fresh produce, a great selection of baked goods, and a variety of affordable food and merchandise. They also highlight the good prices and helpful staff.\n\nSome reviews mention the self-checkout can be sensitive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-96bd-715c-8dde-acd4ac6be8f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-96bd-715c-8dde-acd4ac6be8f9",
        "storage_key": "property/6767906449165947/019ff71e-96bd-715c-8dde-acd4ac6be8f9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lidl.com/s/en-US/stores/rock-hill/herrons-ferry-road-1260/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8703542600193277395&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lidl",
      "poi_latitude": "34.9781821",
      "poi_longitude": "-80.9803293",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 888-654-3515",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff71e-a3e5-767e-82ca-b440a56272f9",
        "storage_key": "property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGb6AhuWFVogR0_3_q-ExyXg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_2a429548-45c9-4e28-bb0d-c426daf2189d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Publix Super Market at Cherry Road Crossing",
      "poi_type": "Shopping & Retail",
      "poi_address": "2186 Cherry Rd Ste 101, Rock Hill, SC 29732, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "People say this grocery store offers fresh produce, quality meats, and delicious fried chicken, along with a wide variety of items and great BOGO deals. They also highlight the clean, organized, and well-stocked environment, as well as the friendly, helpful, and professional staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-9451-7708-8804-278a962de291.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-9451-7708-8804-278a962de291",
        "storage_key": "property/6767906449165947/019ff71e-9451-7708-8804-278a962de291.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1485&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=5352496145394125769&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "publix-super-market-at-cherry-road-crossing",
      "poi_latitude": "34.9648199",
      "poi_longitude": "-80.99684189999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-366-7500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff71e-a3e5-767e-82ca-b440a56272f9",
        "storage_key": "property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJHRYclK2IVogRyUvdr-LiR0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_08d06650-fcac-4eda-ba64-db7527e07c4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Harris Teeter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2750 Celanese Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty aids.",
      "poi_long_description": "Customers consistently praise this grocery store for its wide selection of fresh produce, bakery items, and quality meats, including great steaks and fresh seafood. Reviewers also frequently mention the friendly staff and excellent customer service.\n\nSome reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-9b4e-7439-a76b-d59bb226ab29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-9b4e-7439-a76b-d59bb226ab29",
        "storage_key": "property/6767906449165947/019ff71e-9b4e-7439-a76b-d59bb226ab29.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.harristeeter.com/stores/grocery/sc/rock-hill/northwoods-square/097/00149?cid=loc_09700149_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17241822137475296779&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harris-teeter",
      "poi_latitude": "34.9770811",
      "poi_longitude": "-81.02792409999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff71e-a3e5-767e-82ca-b440a56272f9",
        "storage_key": "property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEy_J3yuPVogRC26uCOJBR-8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7fa9ad36-221f-4654-a2a4-1c9373a0f1b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Food Lion",
      "poi_type": "Shopping & Retail",
      "poi_address": "1918 Mt Gallant Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Grocery chain with a bakery, for staples like produce and meats, plus prepared foods, an in-store deli and a hot bar.",
      "poi_long_description": "People say this grocery store offers a wide variety of local produce and a good selection of items, with many finding great deals. They also highlight the clean and organized environment, along with friendly and helpful staff.\n\nSome reviews mention the produce can be moldy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-9847-7177-9694-cb70c03daec7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-9847-7177-9694-cb70c03daec7",
        "storage_key": "property/6767906449165947/019ff71e-9847-7177-9694-cb70c03daec7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.foodlion.com/sc/rock-hill/1918-mt.-gallant-rd.?y_source=1_NTA0Njg3MC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10361966097498220783&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "food-lion",
      "poi_latitude": "34.978674",
      "poi_longitude": "-81.0027444",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-5444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff71e-a3e5-767e-82ca-b440a56272f9",
        "storage_key": "property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8RYsSk-PVogR76gFAEQZzY8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_dd15582d-55f0-4b9d-98c2-dfdd5c961476",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Las Americas Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "1906 N, 1906 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Compact market offering a meat counter, produce, canned goods, snacks, Mexican food items, takeout fares and prepared dishes.",
      "poi_long_description": "People say this market offers delicious and authentic tacos, burritos, and tortas, with a wide variety of fresh meats and produce available in the grocery section. They also highlight the excellent value, especially the 50-cent tacos on Tuesdays, and the friendly, courteous staff. Visitors appreciate the lively, down-home atmosphere and the convenience of outdoor seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-9708-77aa-be53-ac0a3f37a66e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-9708-77aa-be53-ac0a3f37a66e",
        "storage_key": "property/6767906449165947/019ff71e-9708-77aa-be53-ac0a3f37a66e.webp",
        "width": 1280,
        "height": 1240
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=564657913861890352&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "las-americas-supermarket",
      "poi_latitude": "34.9609522",
      "poi_longitude": "-81.00365579999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-980-8151",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff71e-a3e5-767e-82ca-b440a56272f9",
        "storage_key": "property/6767906449165947/019ff71e-a3e5-767e-82ca-b440a56272f9.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE0631LaIVogRMOFZh2ER1gc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_f5a70d74-d90d-425e-b79f-9e42e5fd9f79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "2815 Home Depot Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "Customers consistently praise this store for being well-stocked and organized, offering a great selection of items including higher quality lumber and plants, alongside easy parking. The friendly and knowledgeable staff are also frequently highlighted as a positive aspect of the shopping experience.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-93f8-76ec-89bb-bd1df76d2bd1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-93f8-76ec-89bb-bd1df76d2bd1",
        "storage_key": "property/6767906449165947/019ff71e-93f8-76ec-89bb-bd1df76d2bd1.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.homedepot.com/l/Rock-Hill/SC/Rock-Hill/29730/1114?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=9497073280658901818&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "34.9783353",
      "poi_longitude": "-80.98455899999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-909-2420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc3VNxfmFVogROguHw9RhzIM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_e097a5b6-4226-42d5-a31d-5e698626b5d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1350 Springdale Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "Customers consistently praise this store for its wide selection of home improvement items, including appliances and plants, alongside its better displays compared to competitors. Reviewers also frequently highlight the friendly and knowledgeable staff, as well as the fast service they provide.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-9328-7487-842f-972254ef2ee2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-9328-7487-842f-972254ef2ee2",
        "storage_key": "property/6767906449165947/019ff71e-9328-7487-842f-972254ef2ee2.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/SC-Rock-Hill/0416?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-416-_-na-_-0-_-0&y_source=1_MTE4NDA1Ny03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1906610576749416304&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "34.9388718",
      "poi_longitude": "-80.9621459",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-3170",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2yb0u0CGVogRcM8myDekdRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_3fb13a37-5da0-4684-b836-3df3de244766",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "2377 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "Customers consistently describe this store as clean and well-stocked with a wide variety of products, offering good prices and featuring friendly staff.\n\nOther reviews mention service can be slow and staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-99cd-7355-963f-6ab5d8d8d2e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-99cd-7355-963f-6ab5d8d8d2e7",
        "storage_key": "property/6767906449165947/019ff71e-99cd-7355-963f-6ab5d8d8d2e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/585-rock-hill-sc/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=6330082212652309828&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "34.94377180000001",
      "poi_longitude": "-80.96318710000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-366-9431",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJEwrNvEGGVogRRN0o9Dv42Fc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b4124f28-0634-419e-9e3f-58c807ea3051",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "2474 Cross Pointe Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this store offers a wide variety of bulk items, including fresh food options, and features convenient Scan & Go and curbside services. They also highlight the friendly and helpful staff, clean environment, and good value.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-931c-733a-8e50-8e4ddf19fb43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-931c-733a-8e50-8e4ddf19fb43",
        "storage_key": "property/6767906449165947/019ff71e-931c-733a-8e50-8e4ddf19fb43.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/6236-rock-hill-sc",
      "poi_directions_map_url": "https://maps.google.com/?cid=4743693866656580769&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "34.9385107",
      "poi_longitude": "-80.9584393",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-372-6500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvfWZ8EOGVogRocRDRXD81EE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_ea038c3f-8a60-4b90-a9c4-2ac9932ddc34",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rock Hill Galleria",
      "poi_type": "Shopping & Retail",
      "poi_address": "2301 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Modest enclosed mall drawing locals since 1991 for its large anchor stores & varied specialty shops.",
      "poi_long_description": "People say this mall is clean and well-maintained, with a nice atmosphere, and that the staff are friendly and provide superb service.\n\nOther reviews mention there can be very few stores open and the mall can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-96ae-729e-a960-ad513d2c6248.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-96ae-729e-a960-ad513d2c6248",
        "storage_key": "property/6767906449165947/019ff71e-96ae-729e-a960-ad513d2c6248.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.rockhillgalleria.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13135205956569526276&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-galleria",
      "poi_latitude": "34.9432563",
      "poi_longitude": "-80.96582719999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-1711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJG14BhUCGVogRBPDrZDmgSbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_47df5a1c-e242-4bcd-a5a5-4f857e6e777f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Belk",
      "poi_type": "Shopping & Retail",
      "poi_address": "2251 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Longtime department store chain with brand-name clothing, accessories & cosmetics, plus housewares.",
      "poi_long_description": "People say this department store offers a wide selection of clothing and home goods, including the Free People brand. They also highlight the reasonable prices and great deals, with many mentioning they rarely pay full retail.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff71e-9c97-7164-9a5f-a7763346d39a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff71e-9c97-7164-9a5f-a7763346d39a",
        "storage_key": "property/6767906449165947/019ff71e-9c97-7164-9a5f-a7763346d39a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.belk.com/store/belk-rock-hill-sc/?StoreID=581",
      "poi_directions_map_url": "https://maps.google.com/?cid=3178514215427737439&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "belk",
      "poi_latitude": "34.942476",
      "poi_longitude": "-80.96645900000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-366-9471",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJQ3anaz-GVogRX4cZpNZZHCw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b06016d2-20b3-4a28-b23c-cf5ff3d5ee1c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1522 Meeting Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "People say this department store offers a great selection of quality clothes and other items, and appreciate the convenient self-pickup for online orders. They also highlight the friendly and helpful staff, and the affordable prices.\n\nSome reviews mention there can be long lines.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-43a6-7027-865a-071dc49732dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-43a6-7027-865a-071dc49732dd",
        "storage_key": "property/6767906449165947/019ff77c-43a6-7027-865a-071dc49732dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/sc/rockhill-1138.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=6626790930814732113&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohls",
      "poi_latitude": "34.9438689",
      "poi_longitude": "-80.9585742",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJaZtUv0GGVogRUQf-xz0X91s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_846451d8-4fa7-4163-8572-7070a188dec4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "T.J. Maxx",
      "poi_type": "Shopping & Retail",
      "poi_address": "552 John Ross Pkwy, Rock Hill, SC 29730, USA",
      "poi_short_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_long_description": "Retail chain featuring stylish brand-name apparel, shoes & accessories, plus housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-447c-70aa-b067-e706fa923c89.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-447c-70aa-b067-e706fa923c89",
        "storage_key": "property/6767906449165947/019ff77c-447c-70aa-b067-e706fa923c89.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tjmaxx.tjx.com/store/index.jsp",
      "poi_directions_map_url": "https://maps.google.com/?cid=8561352750913785879&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tj-maxx",
      "poi_latitude": "34.9435541",
      "poi_longitude": "-80.97723289999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-985-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWwDQpCOGVogRF5AHi_cI0HY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_ce2a2026-05ff-4114-8c9f-a8fd50be1642",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "548 John Ross Pkwy, Rock Hill, SC 29730, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Visitors say this store offers a huge selection of merchandise, including a wide variety of items and well-stocked shelves. They also highlight the friendly and professional staff, efficient checkout process, and ample parking.\n\nSome reviews mention there can be a high-pitched ringing sound.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-44e5-762b-9748-1cdc9f3306f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-44e5-762b-9748-1cdc9f3306f7",
        "storage_key": "property/6767906449165947/019ff77c-44e5-762b-9748-1cdc9f3306f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14967223847750596376&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "34.942764",
      "poi_longitude": "-80.9768327",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-964-7291",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJU0WPsdGHVogRGPftLspCts8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_818ae47d-7367-4d76-8cab-1b76da6ff857",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1775 Chamberside Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Customers consistently praise this electronics store for its wide selection of the latest technology and its well-stocked and organized environment. Reviewers also frequently mention the knowledgeable staff who provide excellent service.\n\nSome reviews mention the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4216-73fa-8fd3-54677892efad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4216-73fa-8fd3-54677892efad",
        "storage_key": "property/6767906449165947/019ff77c-4216-73fa-8fd3-54677892efad.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/sc/rock-hill/1775-chamberside-dr-894.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=12914473402035146212&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "34.938873",
      "poi_longitude": "-80.97709499999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-366-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2zqErySGVogR5A2JpSJtObM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_59d165f6-5f0b-46c6-bd99-656f17aefa4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "2468 Cross Pointe Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Customers consistently praise this sporting goods store for its wide selection of products, encompassing firearms, fishing supplies, and apparel, all offered at good prices. Reviewers also frequently mention the knowledgeable staff.\n\nSome reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-40f1-72c7-bb58-a71705ee95c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-40f1-72c7-bb58-a71705ee95c7",
        "storage_key": "property/6767906449165947/019ff77c-40f1-72c7-bb58-a71705ee95c7.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/south-carolina/rock-hill/store-0137",
      "poi_directions_map_url": "https://maps.google.com/?cid=3067906374587311090&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports--outdoors",
      "poi_latitude": "34.9400511",
      "poi_longitude": "-80.957399",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-323-1800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJuxQkcUGGVogR8uNu3Zdkkyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_e8b62cef-e839-4505-a7ad-e1ebfeb45e26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "PetSmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1110 Hospitality Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain featuring a range of pets, supplies & food (most offer grooming, boarding & other services).",
      "poi_long_description": "People say this pet store offers a wide variety of products and services, including grooming, and has a good selection of fish and birds. They also highlight the friendly, helpful, and knowledgeable staff, as well as the clean and well-organized store.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-43b4-72ef-89d2-ad978a25b4dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-43b4-72ef-89d2-ad978a25b4dc",
        "storage_key": "property/6767906449165947/019ff77c-43b4-72ef-89d2-ad978a25b4dc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.petsmart.com/stores/us/sc/rock-hill-store0405.html?utm_source=google&utm_medium=organic&utm_campaign=google-my-business",
      "poi_directions_map_url": "https://maps.google.com/?cid=11240497426014603932&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "petsmart",
      "poi_latitude": "34.9778814",
      "poi_longitude": "-80.9825512",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-817-6610",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJF2wL6vmFVogRnApLsNpE_ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_980eec81-7fdb-43cc-9b69-2f83c148c62a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "CVS",
      "poi_type": "Shopping & Retail",
      "poi_address": "2870 Cherry Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4221-71ca-a9ca-8d2484ec9cc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4221-71ca-a9ca-8d2484ec9cc1",
        "storage_key": "property/6767906449165947/019ff77c-4221-71ca-a9ca-8d2484ec9cc1.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/rock-hill-sc-pharmacies/2870-cherry-road-at-riverwalk-rock-hill-sc-29730/storeid=11450?WT.mc_id=LS_GOOGLE_FS_11450",
      "poi_directions_map_url": "https://maps.google.com/?cid=7065367702091641052&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cvs",
      "poi_latitude": "34.9791286",
      "poi_longitude": "-80.9796446",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-203-6215",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDeOcsFWFVogR3LCwun06DWI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_998b1cc4-8e20-4a5f-9344-9f33134f6ca1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "2376 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4156-73dd-9ee2-79b0b9991aab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4156-73dd-9ee2-79b0b9991aab",
        "storage_key": "property/6767906449165947/019ff77c-4156-73dd-9ee2-79b0b9991aab.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/sc/rock-hill/2376-dave-lyle-blvd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=337614619673771490&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "34.9409546",
      "poi_longitude": "-80.96132329999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 839-248-1162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJIQFUokGGVogR4j2iNLVyrwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_1cf79932-1c66-4bab-a623-8d40371a2409",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Ashley Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "2197 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this furniture store offers a wide selection of quality furniture, including mattresses and bedroom sets, with many styles and color options. Visitors highlight the knowledgeable and patient staff who provide excellent, low-pressure service. They also appreciate the reasonable prices and helpful financing options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-410a-7199-9624-726f35f5e76c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-410a-7199-9624-726f35f5e76c",
        "storage_key": "property/6767906449165947/019ff77c-410a-7199-9624-726f35f5e76c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://stores.ashleyfurniture.com/store/us/south-carolina/rock-hill/2197-dave-lyle-blvd/?utm_source=G&utm_medium=localSEO&utm_campaign=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=14814088839543644397&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ashley-store",
      "poi_latitude": "34.942527",
      "poi_longitude": "-80.96793799999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 839-213-5235",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJldQKdWSHVogR7eATqE83ls0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_23fd6dc4-5eaa-46de-88c1-48b816eb6d81",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rack Room Shoes",
      "poi_type": "Shopping & Retail",
      "poi_address": "2331 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_long_description": "Footwear chain stocking a wide range of brand-name shoes for men, women & kids, plus accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-5c0b-7769-912b-e9bd27b5473d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-5c0b-7769-912b-e9bd27b5473d",
        "storage_key": "property/6767906449165947/019ff77c-5c0b-7769-912b-e9bd27b5473d.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "https://www.rackroomshoes.com/store/20?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=20",
      "poi_directions_map_url": "https://maps.google.com/?cid=12539700673528585552&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rack-room-shoes",
      "poi_latitude": "34.9413747",
      "poi_longitude": "-80.96407359999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-9899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc1-8bae-7588-8d8a-2a7b8b1ee121",
        "storage_key": "property/6767906449165947/019fddc1-8bae-7588-8d8a-2a7b8b1ee121.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJV0tJiUCGVogRUN1lC1P3Ba4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_bf881169-603e-4ce1-8750-b1d2cb507c7c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "The Pump House",
      "poi_type": "Restaurants",
      "poi_address": "575 Herrons Ferry Road, Rock Hill, SC 29730, USA",
      "poi_short_description": "Sophisticated, riverfront outpost featuring New American cuisine, craft cocktails & a rooftop bar.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious Southern-inspired cuisine, particularly the shrimp and grits, fried okra, and flavorful steaks. The inviting atmosphere and beautiful river views further enhance the dining experience, making it an ideal choice for special occasions.\n\nSome reviews mention the food quality can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-472e-7231-903c-0738f37526f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-472e-7231-903c-0738f37526f0",
        "storage_key": "property/6767906449165947/019ff77c-472e-7231-903c-0738f37526f0.webp",
        "width": 600,
        "height": 449
      },
      "poi_business_url": "https://rockhillpumphouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16827820704898329489&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-pump-house",
      "poi_latitude": "34.9849014",
      "poi_longitude": "-80.9737537",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ85Mg1e6FVogRkattA8ZtiOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_57bddef2-a545-417b-b105-8fbd878a4c8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Richie's Italian Bistro at Riverwalk",
      "poi_type": "Restaurants",
      "poi_address": "819 Terrace Park Ste 103, Rock Hill, SC 29730, USA",
      "poi_short_description": "Casual eatery for New York-style pizza and wine.",
      "poi_long_description": "Diners like this Italian restaurant's delicious and fresh food, especially the pizza, meatballs, and garlic knots, with generous portions. They also highlight the friendly staff, welcoming atmosphere, and fair prices.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4a5a-751d-be4c-e8b1f86c5767.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4a5a-751d-be4c-e8b1f86c5767",
        "storage_key": "property/6767906449165947/019ff77c-4a5a-751d-be4c-e8b1f86c5767.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://richiesitalianbistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14232435241377436117&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "richies-italian-bistro-at-riverwalk",
      "poi_latitude": "34.9831079",
      "poi_longitude": "-80.9726209",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-327-4992",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm8smrb6FVogR1ZENA3LEg8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_14b74395-b837-4ddb-9f4a-149abf6608fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "KONNICHIWA ROCK HILL",
      "poi_type": "Restaurants",
      "poi_address": "1425 Riverchase Blvd, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this Japanese restaurant offers delicious and fresh sushi, including popular options like the Godzilla and Volcano rolls, along with hearty hibachi bowls and excellent crab rangoons. They also highlight the fair prices for large portions and the clean, inviting atmosphere. Guests mention the staff, especially Sam and Koi, provide attentive, friendly, and accommodating service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-49ef-703b-851d-912b77d97bce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-49ef-703b-851d-912b77d97bce",
        "storage_key": "property/6767906449165947/019ff77c-49ef-703b-851d-912b77d97bce.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://konnichiwarestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16945711847065591801&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "konnichiwa-rock-hill",
      "poi_latitude": "34.9775733",
      "poi_longitude": "-80.99198919999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-980-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJxwCnVgCPVogR-R95hiRDK-s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_94002418-1653-42c9-87e2-3d6d82724a3e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Pita Express Mediterranean Grill",
      "poi_type": "Restaurants",
      "poi_address": "2751 Cherry Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "",
      "poi_long_description": "Diners like this restaurant's delicious and fresh Mediterranean food, including flavorful wraps, shawarma, and poutine, with generous portions. They also highlight the excellent value and the welcoming, local-favorite vibe. Others mention the friendly and attentive staff, who provide great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-48ba-764f-b597-e4835a918ef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-48ba-764f-b597-e4835a918ef8",
        "storage_key": "property/6767906449165947/019ff77c-48ba-764f-b597-e4835a918ef8.webp",
        "width": 799,
        "height": 1280
      },
      "poi_business_url": "https://www.facebook.com/p/Pita-Express-Rock-Hill-SC-61587390591772/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10369646258894374011&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "pita-express-mediterranean-grill",
      "poi_latitude": "34.9752361",
      "poi_longitude": "-80.98520429999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-4008",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7UaJu1iFVogRe4Tb61Ri6I8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mediterranean_restaurant"
    },
    {
      "id": "custom_832ff603-69b2-425d-89c1-2c979c5d7f2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Hickory Tavern",
      "poi_type": "Restaurants",
      "poi_address": "2674 Celanese Rd Apt 101, Rock Hill, SC 29732, USA",
      "poi_short_description": "Sports bar & grill chain with an extensive menu of typical bar food & TVs galore.",
      "poi_long_description": "Diners praise this tavern's delicious food, particularly the wings, crab soup, and cedar plank salmon, and enjoy the great atmosphere. The friendly staff are also frequently mentioned for their excellent service.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4945-73da-88fc-c708bbaaa1b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4945-73da-88fc-c708bbaaa1b7",
        "storage_key": "property/6767906449165947/019ff77c-4945-73da-88fc-c708bbaaa1b7.webp",
        "width": 1280,
        "height": 594
      },
      "poi_business_url": "https://www.thehickorytavern.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1546645389720333307&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hickory-tavern",
      "poi_latitude": "34.9766025",
      "poi_longitude": "-81.0246322",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-329-9797",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl96Sfi6PVogR-6vGl8nJdhU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_23eac1ba-872c-48f0-953a-2945096f217b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Kobe Japanese Steakhouse of Rock Hill",
      "poi_type": "Restaurants",
      "poi_address": "2685 Celanese Rd #112, Rock Hill, SC 29732, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this restaurant offers delicious and fresh sushi, flavorful ramen, and well-seasoned hibachi dishes with generous portions. They also highlight the reasonable prices, especially for lunch specials, and the clean, inviting atmosphere. Visitors consistently praise the friendly, attentive, and efficient staff, noting their welcoming service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4d14-7169-ad3c-a1cc1b19ef83.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4d14-7169-ad3c-a1cc1b19ef83",
        "storage_key": "property/6767906449165947/019ff77c-4d14-7169-ad3c-a1cc1b19ef83.webp",
        "width": 1280,
        "height": 860
      },
      "poi_business_url": "https://koberockhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7514079714639732909&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kobe-japanese-steakhouse-of-rock-hill",
      "poi_latitude": "34.9745383",
      "poi_longitude": "-81.0241538",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-2244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2ZpS_HKPVogRreARbbBfR2g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_efa56f16-1fde-45fb-b4bd-c6702d862ed2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Eggs Up Grill",
      "poi_type": "Restaurants",
      "poi_address": "2732 Celanese Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Relaxed chain serving a menu of breakfast, burgers & sandwiches in a colorful setting.",
      "poi_long_description": "Guests consistently praise this restaurant for its delicious breakfast and lunch, featuring favorites like biscuits and gravy, shrimp and grits, and gluten-free pancakes, all served in generous portions. The friendly staff, clean and inviting atmosphere, and reasonable prices further enhance the dining experience.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4c9e-722f-9bf6-32c15b077550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4c9e-722f-9bf6-32c15b077550",
        "storage_key": "property/6767906449165947/019ff77c-4c9e-722f-9bf6-32c15b077550.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.eggsupgrill.com/sc/rock-hill/23/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6386773140130093541&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eggs-up-grill",
      "poi_latitude": "34.977382",
      "poi_longitude": "-81.02699489999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-327-3447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP46z4SuPVogR5dl1FlVgolg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_fa5eaa76-8eab-48d6-b53c-2d1d790588a4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "2415 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "People say this fast food restaurant serves fresh chicken strips and fries. They also highlight the friendly staff and the manager's willingness to resolve issues.\n\nSome reviews mention the wait can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-521e-77ba-baab-374c2df71270.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-521e-77ba-baab-374c2df71270",
        "storage_key": "property/6767906449165947/019ff77c-521e-77ba-baab-374c2df71270.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/sc/cherry-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13462956603777026345&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "34.9692872",
      "poi_longitude": "-80.99371819999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-325-1323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ65lbT1OPVogRKQmhirMH1ro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_62a98008-c124-4747-b4ec-3d6aa102e521",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "2367 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Lively chain steakhouse serving American fare with a Southwestern spin amid Texas-themed decor.",
      "poi_long_description": "Diners like this restaurant's delicious steaks, especially the flavorful ribeye, and the freshly baked rolls with cinnamon honey butter. They also highlight the attentive and friendly staff, as well as the lively atmosphere.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-4ea8-715a-8b26-863af7350167.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-4ea8-715a-8b26-863af7350167",
        "storage_key": "property/6767906449165947/019ff77c-4ea8-715a-8b26-863af7350167.webp",
        "width": 1079,
        "height": 555
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/south-carolina/rock-hill?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=6133918735119437275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "34.94186",
      "poi_longitude": "-80.9625484",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-909-7427",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_VIto0GGVogR203oN5cOIFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_acb40843-1f53-46e2-a8d1-ea533f2a083c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Chili's Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "630 Tinsley Way, Rock Hill, SC 29730, USA",
      "poi_short_description": "Family-friendly chain serving classic Tex-Mex & American fare in a Southwestern-style setting.",
      "poi_long_description": "Diners enjoy this restaurant's delicious and well-prepared food, including hearty ribs, and appreciate the fast and friendly service from the staff.\n\nOther reviews mention the food can be inconsistent and the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-502f-714c-9aad-fd49665c1396.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-502f-714c-9aad-fd49665c1396",
        "storage_key": "property/6767906449165947/019ff77c-502f-714c-9aad-fd49665c1396.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chilis.com/locations/us/south-carolina/rock-hill/rock-hill?utm_source=google&utm_medium=local&utm_campaign=Chilis",
      "poi_directions_map_url": "https://maps.google.com/?cid=17405524138356561530&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chilis-grill--bar",
      "poi_latitude": "34.942576",
      "poi_longitude": "-80.974942",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-980-8334",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJlygMJj2GVogRetY6RPzXjPE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_2a63ecb1-a0b4-4718-8efa-147e8e8c028f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "FUJI JAPAN Japanese Steakhouse and Hibachi Grill",
      "poi_type": "Restaurants",
      "poi_address": "2455 Cherry Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Easygoing Japanese steakhouse serving hibachi dishes alongside a sushi bar with rolls & sashimi.",
      "poi_long_description": "Diners like this Japanese restaurant's delicious hibachi and fresh sushi, with many highlighting the generous portions and flavorful dishes like sweet carrots and crab rangoons. They also mention the entertaining hibachi show, friendly staff, and accommodating service for special occasions.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-5291-73cb-a37f-6a0bbf72eff3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-5291-73cb-a37f-6a0bbf72eff3",
        "storage_key": "property/6767906449165947/019ff77c-5291-73cb-a37f-6a0bbf72eff3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fujirockhill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1012880173054107557&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fuji-japan-japanese-steakhouse-and-hibachi-grill",
      "poi_latitude": "34.97032799999999",
      "poi_longitude": "-80.992685",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-327-9940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQR3fVOPVogRpR_toiZ5Dg4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_57917b54-ac2e-47fd-b217-b57d243e44c2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "The Flipside Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "129 Caldwell St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Relaxed bistro with a cool vibe featuring a Southern-style menu, specialty cocktails & draft beer.",
      "poi_long_description": "Diners like this restaurant's delicious and unique menu offerings, including the pecan-crusted trout, juicy burgers, and flavorful shrimp and grits. They also highlight the friendly, attentive staff and the welcoming, relaxed atmosphere. Guests mention the reasonable prices and appreciate the excellent service, even for large groups.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-561d-7308-a845-6c6571863433.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-561d-7308-a845-6c6571863433",
        "storage_key": "property/6767906449165947/019ff77c-561d-7308-a845-6c6571863433.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.theflipsiderestaurant.com/flipside-restaurant",
      "poi_directions_map_url": "https://maps.google.com/?cid=2628468211407580798&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-flipside-restaurant",
      "poi_latitude": "34.9259682",
      "poi_longitude": "-81.0255203",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-324-3547",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJKUpuDlaIVogRfu5afOkxeiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_b0566a96-eff8-4edd-b496-f27c824f2c86",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Kounter",
      "poi_type": "Restaurants",
      "poi_address": "135 E Main St Ste 101, Rock Hill, SC 29730, USA",
      "poi_short_description": "Casual-posh eatery slinging gourmet grub cocktails and beer including staples and creative twists, along with brunch and lunch offerings.",
      "poi_long_description": "Diners like this restaurant's delicious and creative dishes, including the fried ribs, salmon, and unique chicken and waffle sushi. They also highlight the excellent service from the attentive and friendly staff. Guests mention the welcoming atmosphere and appreciate the historical significance of the location.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-5808-7425-910c-7f8f67947ad9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff77c-5808-7425-910c-7f8f67947ad9",
        "storage_key": "property/6767906449165947/019ff77c-5808-7425-910c-7f8f67947ad9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.kounterdining.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6457816396428519515&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kounter",
      "poi_latitude": "34.9255673",
      "poi_longitude": "-81.0267303",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 803-328-7333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwUCMBbyJVogRW6jQLczFnlk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_cd009e06-7b5a-4e1a-9a0d-b46ff3b49578",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rock Hill Riverwalk",
      "poi_type": "Entertainment",
      "poi_address": "Piedmont Medical Center Trail, Rock Hill, SC 29730, USA",
      "poi_short_description": "Scenic path along the Catawba River with benches offering kayaking and cycling.",
      "poi_long_description": "People say this riverwalk offers a beautiful, paved trail perfect for walking, biking, and dog walking, with scenic views of the Catawba River. Visitors also highlight the presence of benches, swings, and historical plaques along the trail, as well as convenient restrooms. They also like the peaceful ambiance and the proximity to restaurants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-ca5c-7281-8e1e-9786ff775281.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-ca5c-7281-8e1e-9786ff775281",
        "storage_key": "property/6767906449165947/019ff78d-ca5c-7281-8e1e-9786ff775281.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13289256595559931673&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-riverwalk",
      "poi_latitude": "34.9837739",
      "poi_longitude": "-80.9719738",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc2-071f-76db-a6bf-ca66be96e9db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc2-071f-76db-a6bf-ca66be96e9db",
        "storage_key": "property/6767906449165947/019fddc2-071f-76db-a6bf-ca66be96e9db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJt8BUN-yFVogRGd9d03bsbLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_53b07664-daa1-45bd-ae4a-3b0bce32ca5a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rock Hill Outdoor Center",
      "poi_type": "Entertainment",
      "poi_address": "1307 Riverwalk Parkway, Rock Hill, SC 29730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-cfd5-707e-8be3-85da49b5702c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-cfd5-707e-8be3-85da49b5702c",
        "storage_key": "property/6767906449165947/019ff78d-cfd5-707e-8be3-85da49b5702c.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=392228278349307646&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-outdoor-center",
      "poi_latitude": "34.9737745",
      "poi_longitude": "-80.9662433",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-5627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJH1wnlW-GVogR_p7fgYp5cQU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "race_course"
    },
    {
      "id": "custom_bab7d83c-c160-4b96-b6f1-919e49ff832c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Manchester Meadows Park",
      "poi_type": "Entertainment",
      "poi_address": "337 E Mt Gallant Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "City park with multiple soccer fields, a playground & sheltered picnic areas, plus walking trails.",
      "poi_long_description": "Visitors say this park features well-maintained soccer fields, walking trails, and a playground for children. They also highlight the clean restrooms and the ample, convenient parking. Others mention the park is a great place for family outings and dog walking.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-d1cc-756a-b580-afc0b5d9d55e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-d1cc-756a-b580-afc0b5d9d55e",
        "storage_key": "property/6767906449165947/019ff78d-d1cc-756a-b580-afc0b5d9d55e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.cityofrockhill.com/Home/Components/FacilityDirectory/FacilityDirectory/12/8145",
      "poi_directions_map_url": "https://maps.google.com/?cid=9700416392351357493&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "manchester-meadows-park",
      "poi_latitude": "34.9440169",
      "poi_longitude": "-80.98360319999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-326-3792",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019fddc2-071f-76db-a6bf-ca66be96e9db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fddc2-071f-76db-a6bf-ca66be96e9db",
        "storage_key": "property/6767906449165947/019fddc2-071f-76db-a6bf-ca66be96e9db.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz9hnciCGVogRNZp6V1DNnoY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_9d410714-1914-4a96-ae86-6618ef311394",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Regal Manchester - Rock Hill",
      "poi_type": "Entertainment",
      "poi_address": "1935 Cinema Dr, Rock Hill, SC 29730, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "People say this movie theater has clean facilities, including restrooms, and friendly, helpful staff, with some mentioning good popcorn and efficient ticket pickup.\n\nOther reviews mention the seating can be uncomfortable and the theater can be outdated.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-cac0-7093-a857-21cc3fcde857.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-cac0-7093-a857-21cc3fcde857",
        "storage_key": "property/6767906449165947/019ff78d-cac0-7093-a857-21cc3fcde857.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-manchester-rock-hill-1886?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11380516726765489096&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-manchester---rock-hill",
      "poi_latitude": "34.944534",
      "poi_longitude": "-80.97834999999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb2b-719e-9701-e8901bf309bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb2b-719e-9701-e8901bf309bf",
        "storage_key": "property/6767906449165947/019ff78d-eb2b-719e-9701-e8901bf309bf.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2WLmkSKGVogRyIs_m6q3750",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_4b3e12dd-3e15-4680-87e8-96fc134579de",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Stars and Strikes",
      "poi_type": "Entertainment",
      "poi_address": "2225 Dave Lyle Blvd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Family fun center with bowling, laser tag, an arcade, axe throwing, and an American-style restaurant.",
      "poi_long_description": "People say this entertainment center offers a wide variety of activities, including bowling, laser tag, and arcade games, with many options for all ages. They also highlight the good food and drinks, as well as the clean and well-maintained facilities. Guests mention the friendly and helpful staff, who contribute to a fun and engaging atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-d233-7148-b319-56fe99e76fc4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-d233-7148-b319-56fe99e76fc4",
        "storage_key": "property/6767906449165947/019ff78d-d233-7148-b319-56fe99e76fc4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://starsandstrikes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3945030769914324840&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "stars-and-strikes",
      "poi_latitude": "34.9434755",
      "poi_longitude": "-80.96690219999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 678-965-5707",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw-UZzfGHVogRaKe6ZJWQvzY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_cddc3f2e-6e6b-4ef5-a1ea-ecc205d2e953",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Strikers Family SportsCenter",
      "poi_type": "Entertainment",
      "poi_address": "124 N Anderson Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "Bowling alley, pool hall and game center with a snack bar, a beer selection and friendly service.",
      "poi_long_description": "People say this bowling alley offers well-maintained lanes, a pro shop, and additional amenities like pool tables and arcade games. Guests also highlight the friendly and helpful staff, reasonable prices, and a fun, family-friendly atmosphere.\n\nSome reviews mention the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-c940-77bf-9a7e-ca822be5790c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-c940-77bf-9a7e-ca822be5790c",
        "storage_key": "property/6767906449165947/019ff78d-c940-77bf-9a7e-ca822be5790c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.strikerssc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1176432480853423038&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "strikers-family-sportscenter",
      "poi_latitude": "34.9416606",
      "poi_longitude": "-80.99659679999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-5210",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqW1GDZqIVogRvvN_uxuHUxA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_faa62a9f-d707-4419-9664-5595549431b8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Grapevine - Riverwalk",
      "poi_type": "Entertainment",
      "poi_address": "829 Terrace Park Apt 104, Rock Hill, SC 29730, USA",
      "poi_short_description": "Informal spot for coffee and pastries, plus beers, charcuterie and wines.",
      "poi_long_description": "People say this wine bar offers a top-notch wine selection with a variety of options for casual and serious wine drinkers. They also highlight the cozy atmosphere, making it a great place to unwind.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-d2fe-73bb-8523-720c010c90e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-d2fe-73bb-8523-720c010c90e7",
        "storage_key": "property/6767906449165947/019ff78d-d2fe-73bb-8523-720c010c90e7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.grapevine.wine/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11078737473778064275&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "grapevine---riverwalk",
      "poi_latitude": "34.9833944",
      "poi_longitude": "-80.9724277",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-802-9463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb2d-7242-8606-d8000981258a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb2d-7242-8606-d8000981258a",
        "storage_key": "property/6767906449165947/019ff78d-eb2d-7242-8606-d8000981258a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIS45JuyFVogRk5tZ5AiVv5k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_99787009-bed7-44e8-ac91-8278deec7d5e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Off The Tracks Brewing",
      "poi_type": "Entertainment",
      "poi_address": "502 Cherry Rd #106, Rock Hill, SC 29730, USA",
      "poi_short_description": "Laid-back craft brewery serving a brick-oven-style pizza menu along with a patio and friendly staff.",
      "poi_long_description": "People say this brewery offers delicious pizza, wings, and a variety of decent beer options. They also highlight the great atmosphere and kind staff.\n\nSome reviews mention the food can be poorly prepared.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-ca08-7788-a44f-84ac93c54b6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-ca08-7788-a44f-84ac93c54b6b",
        "storage_key": "property/6767906449165947/019ff78d-ca08-7788-a44f-84ac93c54b6b.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://offthetracksbrewing.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=16695216021553850118&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "off-the-tracks-brewing",
      "poi_latitude": "34.9430724",
      "poi_longitude": "-81.0305734",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-326-6882",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a9-7285-a87b-29d8c7d84bd0",
        "storage_key": "property/6767906449165947/019ff77c-60a9-7285-a87b-29d8c7d84bd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk9SqEGOJVogRBqcgPYRSsec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "brewpub"
    },
    {
      "id": "custom_f0a014c7-206b-4d18-a9da-2537f348a541",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Museum of York County",
      "poi_type": "Entertainment",
      "poi_address": "4621 Mt Gallant Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "Heritage museum with a naturalist center & hands-on programs, plus specimens, a planetarium & store.",
      "poi_long_description": "Visitors say this museum features excellent, interactive, and informative natural history exhibits, including a marvelous planetarium and dedicated areas for young children. They also highlight the reasonable prices and the museum's family-friendly atmosphere. Others mention the helpful and engaging staff, as well as the well-maintained and clean facilities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-d236-7011-ba18-1a574d7b9c1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-d236-7011-ba18-1a574d7b9c1d",
        "storage_key": "property/6767906449165947/019ff78d-d236-7011-ba18-1a574d7b9c1d.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://chmuseums.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11863472374095991765&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "museum-of-york-county",
      "poi_latitude": "35.0100332",
      "poi_longitude": "-81.0628414",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb46-7189-b3fb-4b8542782bc9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb46-7189-b3fb-4b8542782bc9",
        "storage_key": "property/6767906449165947/019ff78d-eb46-7189-b3fb-4b8542782bc9.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Ydzro6OVogR1dOm1ESFo6Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_07c5012e-a8b6-4fe6-a598-aaa77372f8bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Carowinds",
      "poi_type": "Entertainment",
      "poi_address": "North Carolina, USA",
      "poi_short_description": "Seasonal, family-friendly amusement park featuring towering roller coasters, waterslides & more.",
      "poi_long_description": "Visitors say this amusement park offers a great mix of thrilling rides, including Fury 325 and Copperhead Strike, and has plenty of attractions for all ages, like Camp Snoopy and a water park. They also highlight the friendly staff, clean grounds, and the value of season passes for frequent visits.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-cb8f-7418-acf7-6a0c15f84846.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-cb8f-7418-acf7-6a0c15f84846",
        "storage_key": "property/6767906449165947/019ff78d-cb8f-7418-acf7-6a0c15f84846.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carowinds.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638331865982573054&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "carowinds",
      "poi_latitude": "35.1024013",
      "poi_longitude": "-80.9412735",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-588-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLVWj3q-PVogR_hngLo7zfTI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_0c4d521f-6835-485c-9f5f-3edb20db0e21",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Riverwalk YMCA",
      "poi_type": "Major Employers & Offices",
      "poi_address": "998 Riverwalk Parkway, Rock Hill, SC 29730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-d5ae-731b-948a-214c3ff9096b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-d5ae-731b-948a-214c3ff9096b",
        "storage_key": "property/6767906449165947/019ff78d-d5ae-731b-948a-214c3ff9096b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://ymcaup.org/branch/riverwalk/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2418509875005368602&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwalk-ymca",
      "poi_latitude": "34.9770361",
      "poi_longitude": "-80.97770249999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-328-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJoZjElvqFVogRGil44epFkCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "non_profit_organization"
    },
    {
      "id": "custom_ddde0581-b73f-46a5-978a-202b636c1d6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "ISI Elite Training - Rock Hill, SC",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1738 Celanese Rd Ste 103, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-d99e-75c6-99e3-1c454c03704f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-d99e-75c6-99e3-1c454c03704f",
        "storage_key": "property/6767906449165947/019ff78d-d99e-75c6-99e3-1c454c03704f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.isielitetraining.com/isi-location/rock-hill",
      "poi_directions_map_url": "https://maps.google.com/?cid=13257538944770045089&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "isi-elite-training---rock-hill-sc",
      "poi_latitude": "34.9767921",
      "poi_longitude": "-81.0019126",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-4786",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ10wkWmPVogRofTsxm09_Lc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8e521c15-e45a-4bee-b453-b5f9724211da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Atrium Health Urgent Care",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1656 Riverchase Blvd #1800, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-db90-72ef-a376-e4009c29dd8d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-db90-72ef-a376-e4009c29dd8d",
        "storage_key": "property/6767906449165947/019ff78d-db90-72ef-a376-e4009c29dd8d.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-urgent-care-rock-hill?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=1046285683438571616&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "atrium-health-urgent-care",
      "poi_latitude": "34.98007820000001",
      "poi_longitude": "-80.98926569999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-909-1850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw176eSuPVogRYNDuHkknhQ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_95158421-1a96-4288-b629-42c20a0a62e5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Atrium Health Primary Care Shiland Family Medicine",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1656 Riverchase Blvd #2400, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-df7b-740c-b46f-27ada8601403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-df7b-740c-b46f-27ada8601403",
        "storage_key": "property/6767906449165947/019ff78d-df7b-740c-b46f-27ada8601403.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://atriumhealth.org/locations/detail/atrium-health-primary-care-shiland-family-medicine-rock-hill?utm_source=GMB&utm_medium=Organic&utm_campaign=GCR",
      "poi_directions_map_url": "https://maps.google.com/?cid=10476028493378896870&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "atrium-health-primary-care-shiland-family-medicine",
      "poi_latitude": "34.9801025",
      "poi_longitude": "-80.98928719999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-5131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff77c-60a8-73d4-a7e1-7dede72272aa",
        "storage_key": "property/6767906449165947/019ff77c-60a8-73d4-a7e1-7dede72272aa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yH-KCyPVogR5kO4DGlUYpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_db4f4b75-158d-4c20-ace0-769b8652f27f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rock Hill Hospital - Piedmont Medical Network",
      "poi_type": "Major Employers & Offices",
      "poi_address": "222 S Herlong Ave, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-d834-7278-9b15-b77dc184dc1a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-d834-7278-9b15-b77dc184dc1a",
        "storage_key": "property/6767906449165947/019ff78d-d834-7278-9b15-b77dc184dc1a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.piedmontmedicalnetwork.com/?utm_campaign=gmb_listings_mgmt&utm_source=gmb-piedmontmc-rockhill&utm_medium=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4319733036252752549&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-hospital---piedmont-medical-network",
      "poi_latitude": "34.956872",
      "poi_longitude": "-81.0507432",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-329-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb2d-7242-8606-d59a341e0489.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb2d-7242-8606-d59a341e0489",
        "storage_key": "property/6767906449165947/019ff78d-eb2d-7242-8606-d59a341e0489.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJlRei2DiJVogRpWpdPk_G8js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_1613663c-e5b0-42a6-b249-fe31568e9577",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Winthrop University",
      "poi_type": "Major Employers & Offices",
      "poi_address": "701 Oakland Ave, Rock Hill, SC 29733, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-da88-76eb-99ef-6ba71dd81f6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-da88-76eb-99ef-6ba71dd81f6e",
        "storage_key": "property/6767906449165947/019ff78d-da88-76eb-99ef-6ba71dd81f6e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.winthrop.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12948757423612692395&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "winthrop-university",
      "poi_latitude": "34.9394013",
      "poi_longitude": "-81.03199699999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-323-2211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb01-710e-aac0-b38a03f2df61",
        "storage_key": "property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6__1m-KIVogRqwcjdUU6s7M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_1bda1f1a-b577-4f43-b562-7d55b501cea8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "York Technical College",
      "poi_type": "Major Employers & Offices",
      "poi_address": "452 Anderson Rd S, Rock Hill, SC 29730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-e1d7-730f-b5f7-1814989ebfc1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-e1d7-730f-b5f7-1814989ebfc1",
        "storage_key": "property/6767906449165947/019ff78d-e1d7-730f-b5f7-1814989ebfc1.webp",
        "width": 1280,
        "height": 885
      },
      "poi_business_url": "http://www.yorktech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7635310615410994742&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "york-technical-college",
      "poi_latitude": "34.935098",
      "poi_longitude": "-80.995289",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-327-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb01-710e-aac0-b38a03f2df61",
        "storage_key": "property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEbhMOoWIVogRNm5XFY0S9mk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_6af1d432-7531-40ed-bbdf-16675caf8807",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Clinton College (HBCU)",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1029 Crawford Rd, Rock Hill, SC 29730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-db4e-774a-ad81-c9be3b98ba6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-db4e-774a-ad81-c9be3b98ba6e",
        "storage_key": "property/6767906449165947/019ff78d-db4e-774a-ad81-c9be3b98ba6e.webp",
        "width": 1080,
        "height": 1080
      },
      "poi_business_url": "https://www.clintoncollege.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13982178984062290010&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "clinton-college-hbcu",
      "poi_latitude": "34.9134144",
      "poi_longitude": "-81.0429245",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-327-7402",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb01-710e-aac0-b38a03f2df61",
        "storage_key": "property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVfwtYLqJVogRWgj3irStCsI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_3d168c0e-1c87-4017-9a9c-098492cf8fa5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Rock Hill Schools",
      "poi_type": "Major Employers & Offices",
      "poi_address": "386 E Black St, Rock Hill, SC 29730, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-ddee-734e-a7d1-7b7093ef9faa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-ddee-734e-a7d1-7b7093ef9faa",
        "storage_key": "property/6767906449165947/019ff78d-ddee-734e-a7d1-7b7093ef9faa.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7519286559586590375&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rock-hill-schools",
      "poi_latitude": "34.92178570000001",
      "poi_longitude": "-81.0230563",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-981-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb01-710e-aac0-b38a03f2df61",
        "storage_key": "property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_____6SIVogRpx6HfEnfWWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5d0c3bc2-cc8b-486a-8bf5-d773fb57694f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Northwestern High School",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2503 W Main St, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-df26-741c-bb48-08afb09b4b42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-df26-741c-bb48-08afb09b4b42",
        "storage_key": "property/6767906449165947/019ff78d-df26-741c-bb48-08afb09b4b42.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "https://nwhs.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16834283851286904005&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "northwestern-high-school",
      "poi_latitude": "34.9502215",
      "poi_longitude": "-81.08301449999999",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-981-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb01-710e-aac0-b38a03f2df61",
        "storage_key": "property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD5_0sd2LVogRxfwMjPhjn-k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ffcd958a-3502-45b4-ae9f-c7ffc08618aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Dutchman Creek Middle School",
      "poi_type": "Major Employers & Offices",
      "poi_address": "4757 Mt Gallant Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://dcms.rock-hill.k12.sc.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17516740201091065649&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dutchman-creek-middle-school",
      "poi_latitude": "35.0082507",
      "poi_longitude": "-81.0660345",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-985-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb01-710e-aac0-b38a03f2df61",
        "storage_key": "property/6767906449165947/019ff78d-eb01-710e-aac0-b38a03f2df61.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf5Z7sq-PVogRMWfWvGf2F_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_e90360f7-a0d8-4f32-8d84-1c8bf8a00d92",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "York County Library",
      "poi_type": "Major Employers & Offices",
      "poi_address": "138 E Black St, Rock Hill, SC 29730, USA",
      "poi_short_description": "Library with a kids section and free genealogy sessions.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-de68-77c4-873c-6d384245153a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-de68-77c4-873c-6d384245153a",
        "storage_key": "property/6767906449165947/019ff78d-de68-77c4-873c-6d384245153a.webp",
        "width": 1076,
        "height": 768
      },
      "poi_business_url": "https://www.yclibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17228081395597723792&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "york-county-library",
      "poi_latitude": "34.9248181",
      "poi_longitude": "-81.0282599",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 803-981-5858",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb47-776d-aa9b-b087b8c02619.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb47-776d-aa9b-b087b8c02619",
        "storage_key": "property/6767906449165947/019ff78d-eb47-776d-aa9b-b087b8c02619.webp",
        "width": 192,
        "height": 174
      },
      "poi_google_place_id": "ChIJ48aesVWIVogRkEgeQsBwFu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_49a96dcd-ae5d-425f-9b57-46ac64e372d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2191 Ebenezer Rd, Rock Hill, SC 29732, USA",
      "poi_short_description": "U.S. Postal Service branch for mail and package delivery services, money orders, and other shipping and logistics tasks.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-e175-761c-b5e2-c256b3218695.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-e175-761c-b5e2-c256b3218695",
        "storage_key": "property/6767906449165947/019ff78d-e175-761c-b5e2-c256b3218695.webp",
        "width": 720,
        "height": 730
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1361996?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=10358156536144321948&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "34.96847169999999",
      "poi_longitude": "-81.0537265",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb04-7654-a95a-f46528f7a698.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb04-7654-a95a-f46528f7a698",
        "storage_key": "property/6767906449165947/019ff78d-eb04-7654-a95a-f46528f7a698.webp",
        "width": 192,
        "height": 157
      },
      "poi_google_place_id": "ChIJJ40ljDWJVogRnN3FYH2Qv48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    },
    {
      "id": "custom_048e088a-8d65-40fd-b9bb-ee338c2a42a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "poi_name": "Charlotte Douglas International Airport",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5501 Josh Birmingham Pkwy, Charlotte, NC 28208, USA",
      "poi_short_description": "Airport with rocking chairs, free WiFi & a 60-foot outdoor sculpture symbolizing flight.",
      "poi_long_description": "Visitors say this airport is clean, well-organized, and easy to navigate, with plenty of food and shopping options, and staff are often friendly and helpful.\n\nOther reviews mention the airport can be overcrowded and there can be frequent delays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-e595-715c-939c-78cfa745a9c8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff78d-e595-715c-939c-78cfa745a9c8",
        "storage_key": "property/6767906449165947/019ff78d-e595-715c-939c-78cfa745a9c8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cltairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1925933632275654455&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "charlotte-douglas-international-airport",
      "poi_latitude": "35.2162994",
      "poi_longitude": "-80.95394280000001",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 704-359-4013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019ff78d-eb46-7189-b3fb-4d69f00a326c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff78d-eb46-7189-b3fb-4d69f00a326c",
        "storage_key": "property/6767906449165947/019ff78d-eb46-7189-b3fb-4d69f00a326c.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJidRKt32YVogRN6fEPG9Kuho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    }
  ],
  "office_hours": [
    {
      "id": "custom_113cfb3d-5d12-4661-9f2a-9fc07efad74f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_5b8244c7-1c00-431a-bf30-c7b3611b3cdc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_95f6716a-2822-4d27-89cd-303688aeacbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_91a4ddec-cb40-4689-96db-ba565917a39d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_4d878f1b-fc0c-469b-9943-d83bf15807b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b4694858-e5d0-4e01-8366-00eb01adcc5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_59bc6833-d101-4c51-a2f6-bda2cfc51cbf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "rating": "5",
      "name": "Joshua Ramirez",
      "text": "Maintenance did a great Job on our sink, and came quickly. Thank you Marvin we appreciate you!",
      "date": "2026-05-15",
      "title": "false"
    },
    {
      "id": "custom_26c7c7f5-39fb-4489-bbd1-2a64d706d9d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "rating": "5",
      "name": "Matthew Rice",
      "text": "Dawn did a great job with the tour, very friendly and willing to answer any all questions I had. Looking to move here during the fall semester this coming year.",
      "date": "2026-05-01",
      "title": "false"
    },
    {
      "id": "custom_e3559cbd-bca8-4bc8-976c-dfcade9c6465",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "rating": "5",
      "name": "Patricia Miller",
      "text": "I moved here in July, 2024. My grown children had each lived here when they were young adults. I remember being pleased with their apartments. So I came here when I was widowed and looking for a place just for me. I am glad I did.\n\nThere have been problems arise, like dishwasher not working, a leak in my bathroom or kitchen, or other small things that can happen in any apartment. But every single one has been handled quickly- and done in a professional manner.\n\nThe new owners have made massive progress with getting the grounds in shape. They have installed much more powerful lighting in the breezeways, redone the parking lots, and completed new landscaping around the property. We have a new fitness center and swimming pools have been updated.\n\nI would recommend without hesitation that you check out The Heights and The Summit if you’re looking for a great place to live!!",
      "date": "2026-03-20",
      "title": "false"
    },
    {
      "id": "custom_accf1372-68bf-4d52-95cc-fe8287bf1072",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "rating": "5",
      "name": "Narshanti Jackson",
      "text": "Jericho was very knowledgeable and made my application process very easy. He also was very nice and went above and beyond to make the application process easier. And Taryn also did an excellent job of cleaning the apartment before my move in.",
      "date": "2026-03-06",
      "title": "false"
    },
    {
      "id": "custom_c6dce339-88d9-4a30-ba22-9ac82da44459",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "rating": "5",
      "name": "Ashley Lundy",
      "text": "Domonique was absolutely amazing on my tour! She was very informative, could answer all my questions and just the most positive and amazing attitude! She was patient with me and made this experience amazing.",
      "date": "2026-02-06",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_0cb93a97-7946-42a9-934b-06edc1afdb89",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165947/019e1dd4-192f-70f6-8674-8b7ef7ce8aba.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1dd4-192f-70f6-8674-8b7ef7ce8aba",
        "storage_key": "property/6767906449165947/019e1dd4-192f-70f6-8674-8b7ef7ce8aba.webp",
        "width": 320,
        "height": 180
      },
      "virtual_tour_title": "A3 Floorplan 1BR 1BTH",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.theviewvr.com/?locationId=4956"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01996453-ca6c-777c-ae34-a9e609698968",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rr-living-the-heights-at-rock-hill",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947"
    },
    {
      "lead_collector_id": "019ecbf7-ed6c-71db-9e3e-9151226cf1b8",
      "lead_source": "LANDING_PAGE",
      "name": "The Heights at Rock Hill Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449165947"
    }
  ],
  "hyperlocal_queries": [],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4708"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9000248350"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5479332"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_l_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=l"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_y_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=y"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NJ293F8C"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_af_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=af"
    },
    {
      "ID": "custom_knock_ag_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=ag"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_br_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=br"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_db_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=db"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_l_title",
      "type": "STRING",
      "value": "Locator"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_rp_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=rp"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_y_title",
      "type": "STRING",
      "value": "Yelp"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_zu_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=zu"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "803-866-6466"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_af_title",
      "type": "STRING",
      "value": "Apartment Finder"
    },
    {
      "ID": "custom_knock_ag_title",
      "type": "STRING",
      "value": "Apartment Guide"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_br_title",
      "type": "STRING",
      "value": "Brochure/Flyer"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_db_title",
      "type": "STRING",
      "value": "Drive-by"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "803-721-4006"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_l_number",
      "type": "STRING",
      "value": "803-573-9962"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "803-500-4239"
    },
    {
      "ID": "custom_knock_rp_title",
      "type": "STRING",
      "value": "RentPath"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "803-672-6232"
    },
    {
      "ID": "custom_knock_y_number",
      "type": "STRING",
      "value": "803-927-8788"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "803-676-1258"
    },
    {
      "ID": "custom_knock_zu_title",
      "type": "STRING",
      "value": "Zumper"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_af_number",
      "type": "STRING",
      "value": "803-910-5814"
    },
    {
      "ID": "custom_knock_ag_number",
      "type": "STRING",
      "value": "803-393-8282"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "803-258-5041"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "803-886-9956"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_br_number",
      "type": "STRING",
      "value": "803-919-2467"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "803-902-5780"
    },
    {
      "ID": "custom_knock_db_number",
      "type": "STRING",
      "value": "803-590-7232"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "803-903-5378"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "803-784-1456"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "803-866-4767"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_knock_rp_number",
      "type": "STRING",
      "value": "803-877-6128"
    },
    {
      "ID": "custom_knock_zu_number",
      "type": "STRING",
      "value": "803-974-8774"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "803-884-2743"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "803-941-5592"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "803-886-0871"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "803-784-4043"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "803-965-3308"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "803-575-3896"
    },
    {
      "ID": "custom_knock_refcr_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=refcr"
    },
    {
      "ID": "custom_knock_reffr_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=reffr"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "803-921-0107"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_costar_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=costar"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "803-575-3196"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_refcr_title",
      "type": "STRING",
      "value": "Referral - Current Resident"
    },
    {
      "ID": "custom_knock_reffr_title",
      "type": "STRING",
      "value": "Referral - Former Resident"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "32453291088"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "803-471-4836"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "9029e711f0c25473"
    },
    {
      "ID": "custom_knock_costar_title",
      "type": "STRING",
      "value": "CoStar"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "803-592-6075"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_refcr_number",
      "type": "STRING",
      "value": "803-887-3017"
    },
    {
      "ID": "custom_knock_reffr_number",
      "type": "STRING",
      "value": "803-965-3182"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "803-875-6220"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_costar_number",
      "type": "STRING",
      "value": "803-962-7620"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "803-956-4533"
    },
    {
      "ID": "custom_knock_outbound_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=outbound"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "803-910-4737"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "803-918-6742"
    },
    {
      "ID": "custom_knock_outbound_title",
      "type": "STRING",
      "value": "Outbound"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "803-805-8062"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_outbound_number",
      "type": "STRING",
      "value": "803-268-3013"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "803-886-6203"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.theheightsatrockhill.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6767906449165947/019e84c0-d77f-7368-93ab-a6c7918fba72.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "803-573-4312"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "803-866-4767"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "4708",
  "custom_repli_id": "9000248350",
  "custom_realpage_id": "5479332",
  "custom_knock_a_link": "https://www.theheightsatrockhill.com?utm_knock=a",
  "custom_knock_g_link": "https://www.theheightsatrockhill.com?utm_knock=g",
  "custom_knock_l_link": "https://www.theheightsatrockhill.com?utm_knock=l",
  "custom_knock_r_link": "https://www.theheightsatrockhill.com?utm_knock=r",
  "custom_knock_w_link": "https://www.theheightsatrockhill.com?utm_knock=w",
  "custom_knock_y_link": "https://www.theheightsatrockhill.com?utm_knock=y",
  "custom_knock_z_link": "https://www.theheightsatrockhill.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-NJ293F8C",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_af_link": "https://www.theheightsatrockhill.com?utm_knock=af",
  "custom_knock_ag_link": "https://www.theheightsatrockhill.com?utm_knock=ag",
  "custom_knock_al_link": "https://www.theheightsatrockhill.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.theheightsatrockhill.com?utm_knock=ar",
  "custom_knock_br_link": "https://www.theheightsatrockhill.com?utm_knock=br",
  "custom_knock_cl_link": "https://www.theheightsatrockhill.com?utm_knock=cl",
  "custom_knock_db_link": "https://www.theheightsatrockhill.com?utm_knock=db",
  "custom_knock_fb_link": "https://www.theheightsatrockhill.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.theheightsatrockhill.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.theheightsatrockhill.com?utm_knock=gp",
  "custom_knock_l_title": "Locator",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_rp_link": "https://www.theheightsatrockhill.com?utm_knock=rp",
  "custom_knock_w_title": "Property Website",
  "custom_knock_y_title": "Yelp",
  "custom_knock_z_title": "Zillow",
  "custom_knock_zu_link": "https://www.theheightsatrockhill.com?utm_knock=zu",
  "custom_knock_a_number": "803-866-6466",
  "custom_knock_ads_link": "https://www.theheightsatrockhill.com?utm_knock=ads",
  "custom_knock_af_title": "Apartment Finder",
  "custom_knock_ag_title": "Apartment Guide",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.theheightsatrockhill.com?utm_knock=bnr",
  "custom_knock_br_title": "Brochure/Flyer",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_db_title": "Drive-by",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "803-721-4006",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_l_number": "803-573-9962",
  "custom_knock_lcs_link": "https://www.theheightsatrockhill.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.theheightsatrockhill.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.theheightsatrockhill.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.theheightsatrockhill.com?utm_knock=psa",
  "custom_knock_r_number": "803-500-4239",
  "custom_knock_rp_title": "RentPath",
  "custom_knock_w_number": "803-672-6232",
  "custom_knock_y_number": "803-927-8788",
  "custom_knock_z_number": "803-676-1258",
  "custom_knock_zu_title": "Zumper",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_af_number": "803-910-5814",
  "custom_knock_ag_number": "803-393-8282",
  "custom_knock_al_number": "803-258-5041",
  "custom_knock_amap_link": "https://www.theheightsatrockhill.com?utm_knock=amap",
  "custom_knock_ar_number": "803-886-9956",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_br_number": "803-919-2467",
  "custom_knock_cl_number": "803-902-5780",
  "custom_knock_db_number": "803-590-7232",
  "custom_knock_fb_number": "803-903-5378",
  "custom_knock_fl_number": "803-784-1456",
  "custom_knock_gp_number": "803-866-4767",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.theheightsatrockhill.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_knock_rp_number": "803-877-6128",
  "custom_knock_zu_number": "803-974-8774",
  "custom_ads_subscription": "full_stack",
  "custom_knock_ads_number": "803-884-2743",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.theheightsatrockhill.com?utm_knock=bcard",
  "custom_knock_bnr_number": "803-941-5592",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "803-886-0871",
  "custom_knock_lgp_number": "803-784-4043",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.theheightsatrockhill.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "803-965-3308",
  "custom_knock_psa_number": "803-575-3896",
  "custom_knock_refcr_link": "https://www.theheightsatrockhill.com?utm_knock=refcr",
  "custom_knock_reffr_link": "https://www.theheightsatrockhill.com?utm_knock=reffr",
  "custom_seo_subscription": "full_stack",
  "custom_knock_amap_number": "803-921-0107",
  "custom_knock_bandit_link": "https://www.theheightsatrockhill.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_costar_link": "https://www.theheightsatrockhill.com?utm_knock=costar",
  "custom_knock_flyers_link": "https://www.theheightsatrockhill.com?utm_knock=flyers",
  "custom_knock_osoc_number": "803-575-3196",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_refcr_title": "Referral - Current Resident",
  "custom_knock_reffr_title": "Referral - Former Resident",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "32453291088",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "803-471-4836",
  "custom_knock_chatgpt_link": "https://www.theheightsatrockhill.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "9029e711f0c25473",
  "custom_knock_costar_title": "CoStar",
  "custom_knock_dirmail_link": "https://www.theheightsatrockhill.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "803-592-6075",
  "custom_knock_propbro_link": "https://www.theheightsatrockhill.com?utm_knock=propbro",
  "custom_knock_refcr_number": "803-887-3017",
  "custom_knock_reffr_number": "803-965-3182",
  "custom_knock_bandit_number": "803-875-6220",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_costar_number": "803-962-7620",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "803-956-4533",
  "custom_knock_outbound_link": "https://www.theheightsatrockhill.com?utm_knock=outbound",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.theheightsatrockhill.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "803-910-4737",
  "custom_knock_dirmail_number": "803-918-6742",
  "custom_knock_outbound_title": "Outbound",
  "custom_knock_propbro_number": "803-805-8062",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_outbound_number": "803-268-3013",
  "custom_knock_revcards_number": "803-886-6203",
  "custom_knock_maintenance_link": "https://www.theheightsatrockhill.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6767906449165947/019e84c0-d77f-7368-93ab-a6c7918fba72.mp4",
  "custom_knock_maintenance_number": "803-573-4312",
  "custom_ppc_tracking_phone_number": "803-866-4767",
  "custom_audioeye_site_id": "6886dde2-d361-4b3e-baad-960c14c58c74",
  "custom_audioeye_site_hash": "4cee49968a9c46636114300741644dbc"
};

export const generatedAt = '2026-10-27T16:15:19.944Z';
